import { VendorLocationDetailInfo } from "./../../modules/contacts/components/vendor-location-detail-info";
import { IVendorLocationDto } from "./../contacts-api-dto-interfaces";
/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.6.1.0 (NJsonSchema v10.1.21.0 (Newtonsoft.Json v12.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import axios, {
  AxiosError,
  AxiosInstance,
  AxiosRequestConfig,
  AxiosResponse,
  CancelToken
} from "axios";

export class ContactsClient {
  private instance: AxiosInstance;
  private baseUrl: string;
  protected jsonParseReviver:
    | ((key: string, value: any) => any)
    | undefined = undefined;

  constructor(baseUrl?: string, instance?: AxiosInstance) {
    this.instance = instance ? instance : axios.create();
    this.baseUrl = baseUrl ? baseUrl : "";
  }

  /**
   * Deletes an existing company type, scoped to the company/business unit of the current user.
   * @param id The company type's unique identifier.
   * @param x_Requested_Business_Unit_Id (optional)
   * @return Company type deleted.
   */
  deleteCompanyType(
    id: string,
    x_Requested_Business_Unit_Id?: any | undefined,
    cancelToken?: CancelToken | undefined
  ): Promise<void> {
    let url_ = this.baseUrl + "/api/v1/companyTypes/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_ = <AxiosRequestConfig>{
      method: "DELETE",
      url: url_,
      headers: {
        "X-Requested-Business-Unit-Id":
          x_Requested_Business_Unit_Id !== undefined &&
          x_Requested_Business_Unit_Id !== null
            ? "" + x_Requested_Business_Unit_Id
            : ""
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processDeleteCompanyType(_response);
      });
  }

  protected processDeleteCompanyType(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 204) {
      const _responseText = response.data;
      return Promise.resolve<void>(<any>null);
    } else if (status === 404) {
      const _responseText = response.data;
      let result404: any = null;
      let resultData404 = _responseText;
      result404 = ProblemDetails.fromJS(resultData404);
      return throwException(
        "Company type not found.",
        status,
        _responseText,
        _headers,
        result404
      );
    } else if (status === 401) {
      const _responseText = response.data;
      return throwException("Unauthorized", status, _responseText, _headers);
    } else if (status === 403) {
      const _responseText = response.data;
      return throwException("Forbidden", status, _responseText, _headers);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<void>(<any>null);
  }

  /**
     * Returns the company type specified by the unique identifier,
    scoped to the company/business unit of the current user.
     * @param id The company type's unique identifier.
     * @param x_Requested_Business_Unit_Id (optional) 
     * @return Success
     */
  getCompanyType(
    id: string,
    x_Requested_Business_Unit_Id?: any | undefined,
    cancelToken?: CancelToken | undefined
  ): Promise<CompanyTypeDto> {
    let url_ = this.baseUrl + "/api/v1/companyTypes/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_ = <AxiosRequestConfig>{
      method: "GET",
      url: url_,
      headers: {
        "X-Requested-Business-Unit-Id":
          x_Requested_Business_Unit_Id !== undefined &&
          x_Requested_Business_Unit_Id !== null
            ? "" + x_Requested_Business_Unit_Id
            : "",
        Accept: "application/json"
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetCompanyType(_response);
      });
  }

  protected processGetCompanyType(
    response: AxiosResponse
  ): Promise<CompanyTypeDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = CompanyTypeDto.fromJS(resultData200);
      return result200;
    } else if (status === 404) {
      const _responseText = response.data;
      let result404: any = null;
      let resultData404 = _responseText;
      result404 = ProblemDetails.fromJS(resultData404);
      return throwException(
        "Company type not found.",
        status,
        _responseText,
        _headers,
        result404
      );
    } else if (status === 401) {
      const _responseText = response.data;
      return throwException("Unauthorized", status, _responseText, _headers);
    } else if (status === 403) {
      const _responseText = response.data;
      return throwException("Forbidden", status, _responseText, _headers);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<CompanyTypeDto>(<any>null);
  }

  /**
   * Updates an existing company type, scoped to the company/business unit of the current user.
   * @param id The company type's unique identifier.
   * @param x_Requested_Business_Unit_Id (optional)
   * @param body (optional) The updated company type.
   * @return Company type updated.
   */
  updateCompanyType(
    id: string,
    x_Requested_Business_Unit_Id?: any | undefined,
    body?: UpdateCompanyTypeDto | undefined,
    cancelToken?: CancelToken | undefined
  ): Promise<void> {
    let url_ = this.baseUrl + "/api/v1/companyTypes/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_ = <AxiosRequestConfig>{
      data: content_,
      method: "PUT",
      url: url_,
      headers: {
        "X-Requested-Business-Unit-Id":
          x_Requested_Business_Unit_Id !== undefined &&
          x_Requested_Business_Unit_Id !== null
            ? "" + x_Requested_Business_Unit_Id
            : "",
        "Content-Type": "application/json"
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processUpdateCompanyType(_response);
      });
  }

  protected processUpdateCompanyType(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 204) {
      const _responseText = response.data;
      return Promise.resolve<void>(<any>null);
    } else if (status === 409) {
      const _responseText = response.data;
      let result409: any = null;
      let resultData409 = _responseText;
      result409 = ProblemDetails.fromJS(resultData409);
      return throwException(
        "Company type code already in use.",
        status,
        _responseText,
        _headers,
        result409
      );
    } else if (status === 404) {
      const _responseText = response.data;
      let result404: any = null;
      let resultData404 = _responseText;
      result404 = ProblemDetails.fromJS(resultData404);
      return throwException(
        "Company type not found.",
        status,
        _responseText,
        _headers,
        result404
      );
    } else if (status === 401) {
      const _responseText = response.data;
      return throwException("Unauthorized", status, _responseText, _headers);
    } else if (status === 403) {
      const _responseText = response.data;
      return throwException("Forbidden", status, _responseText, _headers);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<void>(<any>null);
  }

  /**
   * Deletes an existing minority type, scoped to the company/business unit of the current user.
   * @param id The minority type's unique identifier.
   * @param x_Requested_Business_Unit_Id (optional)
   * @return Minority type deleted.
   */
  deleteMinorityType(
    id: string,
    x_Requested_Business_Unit_Id?: any | undefined,
    cancelToken?: CancelToken | undefined
  ): Promise<void> {
    let url_ = this.baseUrl + "/api/v1/minorityTypes/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_ = <AxiosRequestConfig>{
      method: "DELETE",
      url: url_,
      headers: {
        "X-Requested-Business-Unit-Id":
          x_Requested_Business_Unit_Id !== undefined &&
          x_Requested_Business_Unit_Id !== null
            ? "" + x_Requested_Business_Unit_Id
            : ""
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processDeleteMinorityType(_response);
      });
  }

  protected processDeleteMinorityType(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 204) {
      const _responseText = response.data;
      return Promise.resolve<void>(<any>null);
    } else if (status === 404) {
      const _responseText = response.data;
      let result404: any = null;
      let resultData404 = _responseText;
      result404 = ProblemDetails.fromJS(resultData404);
      return throwException(
        "Minority type not found.",
        status,
        _responseText,
        _headers,
        result404
      );
    } else if (status === 401) {
      const _responseText = response.data;
      return throwException("Unauthorized", status, _responseText, _headers);
    } else if (status === 403) {
      const _responseText = response.data;
      return throwException("Forbidden", status, _responseText, _headers);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<void>(<any>null);
  }

  /**
     * Returns the minority type specified by the unique identifier,
    scoped to the company/business unit of the current user.
     * @param id The minority type's unique identifier.
     * @param x_Requested_Business_Unit_Id (optional) 
     * @return Success
     */
  getMinorityType(
    id: string,
    x_Requested_Business_Unit_Id?: any | undefined,
    cancelToken?: CancelToken | undefined
  ): Promise<MinorityTypeDto> {
    let url_ = this.baseUrl + "/api/v1/minorityTypes/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_ = <AxiosRequestConfig>{
      method: "GET",
      url: url_,
      headers: {
        "X-Requested-Business-Unit-Id":
          x_Requested_Business_Unit_Id !== undefined &&
          x_Requested_Business_Unit_Id !== null
            ? "" + x_Requested_Business_Unit_Id
            : "",
        Accept: "application/json"
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetMinorityType(_response);
      });
  }

  protected processGetMinorityType(
    response: AxiosResponse
  ): Promise<MinorityTypeDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = MinorityTypeDto.fromJS(resultData200);
      return result200;
    } else if (status === 404) {
      const _responseText = response.data;
      let result404: any = null;
      let resultData404 = _responseText;
      result404 = ProblemDetails.fromJS(resultData404);
      return throwException(
        "Minority type not found.",
        status,
        _responseText,
        _headers,
        result404
      );
    } else if (status === 401) {
      const _responseText = response.data;
      return throwException("Unauthorized", status, _responseText, _headers);
    } else if (status === 403) {
      const _responseText = response.data;
      return throwException("Forbidden", status, _responseText, _headers);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<MinorityTypeDto>(<any>null);
  }

  /**
   * Updates an existing minority type, scoped to the company/business unit of the current user.
   * @param x_Requested_Business_Unit_Id (optional)
   * @param body (optional)
   * @return Minority type updated.
   */
  updateMinorityType(
    id: string,
    x_Requested_Business_Unit_Id?: any | undefined,
    body?: UpdateMinorityTypeDto | undefined,
    cancelToken?: CancelToken | undefined
  ): Promise<void> {
    let url_ = this.baseUrl + "/api/v1/minorityTypes/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_ = <AxiosRequestConfig>{
      data: content_,
      method: "PUT",
      url: url_,
      headers: {
        "X-Requested-Business-Unit-Id":
          x_Requested_Business_Unit_Id !== undefined &&
          x_Requested_Business_Unit_Id !== null
            ? "" + x_Requested_Business_Unit_Id
            : "",
        "Content-Type": "application/json"
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processUpdateMinorityType(_response);
      });
  }

  protected processUpdateMinorityType(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 204) {
      const _responseText = response.data;
      return Promise.resolve<void>(<any>null);
    } else if (status === 409) {
      const _responseText = response.data;
      let result409: any = null;
      let resultData409 = _responseText;
      result409 = ProblemDetails.fromJS(resultData409);
      return throwException(
        "Minority type code already in use.",
        status,
        _responseText,
        _headers,
        result409
      );
    } else if (status === 404) {
      const _responseText = response.data;
      let result404: any = null;
      let resultData404 = _responseText;
      result404 = ProblemDetails.fromJS(resultData404);
      return throwException(
        "Minority type not found.",
        status,
        _responseText,
        _headers,
        result404
      );
    } else if (status === 401) {
      const _responseText = response.data;
      return throwException("Unauthorized", status, _responseText, _headers);
    } else if (status === 403) {
      const _responseText = response.data;
      return throwException("Forbidden", status, _responseText, _headers);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<void>(<any>null);
  }

  /**
   * Deletes an existing product type, scoped to the company/business unit of the current user.
   * @param id The product type's unique identifier.
   * @param x_Requested_Business_Unit_Id (optional)
   * @return Product type deleted.
   */
  deleteProductType(
    id: string,
    x_Requested_Business_Unit_Id?: any | undefined,
    cancelToken?: CancelToken | undefined
  ): Promise<void> {
    let url_ = this.baseUrl + "/api/v1/productTypes/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_ = <AxiosRequestConfig>{
      method: "DELETE",
      url: url_,
      headers: {
        "X-Requested-Business-Unit-Id":
          x_Requested_Business_Unit_Id !== undefined &&
          x_Requested_Business_Unit_Id !== null
            ? "" + x_Requested_Business_Unit_Id
            : ""
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processDeleteProductType(_response);
      });
  }

  protected processDeleteProductType(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 204) {
      const _responseText = response.data;
      return Promise.resolve<void>(<any>null);
    } else if (status === 404) {
      const _responseText = response.data;
      let result404: any = null;
      let resultData404 = _responseText;
      result404 = ProblemDetails.fromJS(resultData404);
      return throwException(
        "Product type not found.",
        status,
        _responseText,
        _headers,
        result404
      );
    } else if (status === 401) {
      const _responseText = response.data;
      return throwException("Unauthorized", status, _responseText, _headers);
    } else if (status === 403) {
      const _responseText = response.data;
      return throwException("Forbidden", status, _responseText, _headers);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<void>(<any>null);
  }

  /**
     * Returns the product type specified by the unique identifier,
    scoped to the company/business unit of the current user.
     * @param id The product type's unique identifier.
     * @param x_Requested_Business_Unit_Id (optional) 
     * @return Success
     */
  getProductType(
    id: string,
    x_Requested_Business_Unit_Id?: any | undefined,
    cancelToken?: CancelToken | undefined
  ): Promise<ProductTypeDto> {
    let url_ = this.baseUrl + "/api/v1/productTypes/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_ = <AxiosRequestConfig>{
      method: "GET",
      url: url_,
      headers: {
        "X-Requested-Business-Unit-Id":
          x_Requested_Business_Unit_Id !== undefined &&
          x_Requested_Business_Unit_Id !== null
            ? "" + x_Requested_Business_Unit_Id
            : "",
        Accept: "application/json"
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetProductType(_response);
      });
  }

  protected processGetProductType(
    response: AxiosResponse
  ): Promise<ProductTypeDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = ProductTypeDto.fromJS(resultData200);
      return result200;
    } else if (status === 404) {
      const _responseText = response.data;
      let result404: any = null;
      let resultData404 = _responseText;
      result404 = ProblemDetails.fromJS(resultData404);
      return throwException(
        "Product type not found.",
        status,
        _responseText,
        _headers,
        result404
      );
    } else if (status === 401) {
      const _responseText = response.data;
      return throwException("Unauthorized", status, _responseText, _headers);
    } else if (status === 403) {
      const _responseText = response.data;
      return throwException("Forbidden", status, _responseText, _headers);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<ProductTypeDto>(<any>null);
  }

  /**
   * Updates an existing product type, scoped to the company/business unit of the current user.
   * @param x_Requested_Business_Unit_Id (optional)
   * @param body (optional)
   * @return Product type updated.
   */
  updateProductType(
    id: string,
    x_Requested_Business_Unit_Id?: any | undefined,
    body?: UpdateProductTypeDto | undefined,
    cancelToken?: CancelToken | undefined
  ): Promise<void> {
    let url_ = this.baseUrl + "/api/v1/productTypes/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_ = <AxiosRequestConfig>{
      data: content_,
      method: "PUT",
      url: url_,
      headers: {
        "X-Requested-Business-Unit-Id":
          x_Requested_Business_Unit_Id !== undefined &&
          x_Requested_Business_Unit_Id !== null
            ? "" + x_Requested_Business_Unit_Id
            : "",
        "Content-Type": "application/json"
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processUpdateProductType(_response);
      });
  }

  protected processUpdateProductType(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 204) {
      const _responseText = response.data;
      return Promise.resolve<void>(<any>null);
    } else if (status === 409) {
      const _responseText = response.data;
      let result409: any = null;
      let resultData409 = _responseText;
      result409 = ProblemDetails.fromJS(resultData409);
      return throwException(
        "Product type code already in use.",
        status,
        _responseText,
        _headers,
        result409
      );
    } else if (status === 404) {
      const _responseText = response.data;
      let result404: any = null;
      let resultData404 = _responseText;
      result404 = ProblemDetails.fromJS(resultData404);
      return throwException(
        "Product type not found.",
        status,
        _responseText,
        _headers,
        result404
      );
    } else if (status === 401) {
      const _responseText = response.data;
      return throwException("Unauthorized", status, _responseText, _headers);
    } else if (status === 403) {
      const _responseText = response.data;
      return throwException("Forbidden", status, _responseText, _headers);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<void>(<any>null);
  }

  /**
   * Deletes a profile, scoped to the company/business unit of the current user.
   * @param x_Requested_Business_Unit_Id (optional)
   * @return Successfully deleted the profile.
   */
  deleteProfile(
    id: string,
    x_Requested_Business_Unit_Id?: any | undefined,
    cancelToken?: CancelToken | undefined
  ): Promise<void> {
    let url_ = this.baseUrl + "/api/v1/profiles/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_ = <AxiosRequestConfig>{
      method: "DELETE",
      url: url_,
      headers: {
        "X-Requested-Business-Unit-Id":
          x_Requested_Business_Unit_Id !== undefined &&
          x_Requested_Business_Unit_Id !== null
            ? "" + x_Requested_Business_Unit_Id
            : ""
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processDeleteProfile(_response);
      });
  }

  protected processDeleteProfile(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 204) {
      const _responseText = response.data;
      return Promise.resolve<void>(<any>null);
    } else if (status === 404) {
      const _responseText = response.data;
      let result404: any = null;
      let resultData404 = _responseText;
      result404 = ProblemDetails.fromJS(resultData404);
      return throwException(
        "Profile not found.",
        status,
        _responseText,
        _headers,
        result404
      );
    } else if (status === 401) {
      const _responseText = response.data;
      return throwException("Unauthorized", status, _responseText, _headers);
    } else if (status === 403) {
      const _responseText = response.data;
      return throwException("Forbidden", status, _responseText, _headers);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<void>(<any>null);
  }

  /**
   * Returns the profile specified by the unique identifier.
   * @param id The profile's unique identifier.
   * @param x_Requested_Business_Unit_Id (optional)
   * @return Success
   */
  getProfile(
    id: string,
    x_Requested_Business_Unit_Id?: any | undefined,
    cancelToken?: CancelToken | undefined
  ): Promise<ProfileDto> {
    let url_ = this.baseUrl + "/api/v1/profiles/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_ = <AxiosRequestConfig>{
      method: "GET",
      url: url_,
      headers: {
        "X-Requested-Business-Unit-Id":
          x_Requested_Business_Unit_Id !== undefined &&
          x_Requested_Business_Unit_Id !== null
            ? "" + x_Requested_Business_Unit_Id
            : "",
        Accept: "application/json"
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetProfile(_response);
      });
  }

  protected processGetProfile(response: AxiosResponse): Promise<ProfileDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = ProfileDto.fromJS(resultData200);
      return result200;
    } else if (status === 404) {
      const _responseText = response.data;
      let result404: any = null;
      let resultData404 = _responseText;
      result404 = ProblemDetails.fromJS(resultData404);
      return throwException(
        "Profile not found",
        status,
        _responseText,
        _headers,
        result404
      );
    } else if (status === 401) {
      const _responseText = response.data;
      return throwException("Unauthorized", status, _responseText, _headers);
    } else if (status === 403) {
      const _responseText = response.data;
      return throwException("Forbidden", status, _responseText, _headers);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<ProfileDto>(<any>null);
  }

  /**
   * Deletes the specified contact, scoped to the company/business unit of the current user.
   * @param x_Requested_Business_Unit_Id (optional)
   * @return Successfully deleted contact.
   */
  deleteProfileContact(
    id: string,
    x_Requested_Business_Unit_Id?: any | undefined,
    cancelToken?: CancelToken | undefined
  ): Promise<void> {
    let url_ = this.baseUrl + "/api/v1/profiles/contacts/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_ = <AxiosRequestConfig>{
      method: "DELETE",
      url: url_,
      headers: {
        "X-Requested-Business-Unit-Id":
          x_Requested_Business_Unit_Id !== undefined &&
          x_Requested_Business_Unit_Id !== null
            ? "" + x_Requested_Business_Unit_Id
            : ""
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processDeleteProfileContact(_response);
      });
  }

  protected processDeleteProfileContact(
    response: AxiosResponse
  ): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 204) {
      const _responseText = response.data;
      return Promise.resolve<void>(<any>null);
    } else if (status === 404) {
      const _responseText = response.data;
      let result404: any = null;
      let resultData404 = _responseText;
      result404 = ProblemDetails.fromJS(resultData404);
      return throwException(
        "Profile/Contact not found.",
        status,
        _responseText,
        _headers,
        result404
      );
    } else if (status === 401) {
      const _responseText = response.data;
      return throwException("Unauthorized", status, _responseText, _headers);
    } else if (status === 403) {
      const _responseText = response.data;
      return throwException("Forbidden", status, _responseText, _headers);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<void>(<any>null);
  }

  /**
   * Updates the specified contact, scoped to the company/business unit of the current user.
   * @param x_Requested_Business_Unit_Id (optional)
   * @param body (optional)
   * @return Successfully updated contact.
   */
  updateProfileContact(
    id: string,
    x_Requested_Business_Unit_Id?: any | undefined,
    body?: UpdateProfileContactDto | undefined,
    cancelToken?: CancelToken | undefined
  ): Promise<void> {
    let url_ = this.baseUrl + "/api/v1/profiles/contacts/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_ = <AxiosRequestConfig>{
      data: content_,
      method: "PUT",
      url: url_,
      headers: {
        "X-Requested-Business-Unit-Id":
          x_Requested_Business_Unit_Id !== undefined &&
          x_Requested_Business_Unit_Id !== null
            ? "" + x_Requested_Business_Unit_Id
            : "",
        "Content-Type": "application/json"
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processUpdateProfileContact(_response);
      });
  }

  protected processUpdateProfileContact(
    response: AxiosResponse
  ): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 204) {
      const _responseText = response.data;
      return Promise.resolve<void>(<any>null);
    } else if (status === 404) {
      const _responseText = response.data;
      let result404: any = null;
      let resultData404 = _responseText;
      result404 = ProblemDetails.fromJS(resultData404);
      return throwException(
        "Profile/Contact not found.",
        status,
        _responseText,
        _headers,
        result404
      );
    } else if (status === 401) {
      const _responseText = response.data;
      return throwException("Unauthorized", status, _responseText, _headers);
    } else if (status === 403) {
      const _responseText = response.data;
      return throwException("Forbidden", status, _responseText, _headers);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<void>(<any>null);
  }

  /**
   * Deletes the specified minority status, scoped to the company/business unit of the current user.
   * @param x_Requested_Business_Unit_Id (optional)
   * @return Successfully deleted status.
   */
  deleteProfileMinorityStatus(
    id: string,
    x_Requested_Business_Unit_Id?: any | undefined,
    cancelToken?: CancelToken | undefined
  ): Promise<void> {
    let url_ = this.baseUrl + "/api/v1/profiles/statuses/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_ = <AxiosRequestConfig>{
      method: "DELETE",
      url: url_,
      headers: {
        "X-Requested-Business-Unit-Id":
          x_Requested_Business_Unit_Id !== undefined &&
          x_Requested_Business_Unit_Id !== null
            ? "" + x_Requested_Business_Unit_Id
            : ""
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processDeleteProfileMinorityStatus(_response);
      });
  }

  protected processDeleteProfileMinorityStatus(
    response: AxiosResponse
  ): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 204) {
      const _responseText = response.data;
      return Promise.resolve<void>(<any>null);
    } else if (status === 404) {
      const _responseText = response.data;
      let result404: any = null;
      let resultData404 = _responseText;
      result404 = ProblemDetails.fromJS(resultData404);
      return throwException(
        "Profile/Minority Status not found.",
        status,
        _responseText,
        _headers,
        result404
      );
    } else if (status === 401) {
      const _responseText = response.data;
      return throwException("Unauthorized", status, _responseText, _headers);
    } else if (status === 403) {
      const _responseText = response.data;
      return throwException("Forbidden", status, _responseText, _headers);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<void>(<any>null);
  }

  /**
   * Updates the specified minority status, scoped to the company/business unit of the current user.
   * @param x_Requested_Business_Unit_Id (optional)
   * @param body (optional)
   * @return Successfully updated minority status.
   */
  updateProfileMinoirtyStatus(
    id: string,
    x_Requested_Business_Unit_Id?: any | undefined,
    body?: UpdateProfileMinorityStatusDto | undefined,
    cancelToken?: CancelToken | undefined
  ): Promise<void> {
    let url_ = this.baseUrl + "/api/v1/profiles/statuses/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_ = <AxiosRequestConfig>{
      data: content_,
      method: "PUT",
      url: url_,
      headers: {
        "X-Requested-Business-Unit-Id":
          x_Requested_Business_Unit_Id !== undefined &&
          x_Requested_Business_Unit_Id !== null
            ? "" + x_Requested_Business_Unit_Id
            : "",
        "Content-Type": "application/json"
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processUpdateProfileMinoirtyStatus(_response);
      });
  }

  protected processUpdateProfileMinoirtyStatus(
    response: AxiosResponse
  ): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 204) {
      const _responseText = response.data;
      return Promise.resolve<void>(<any>null);
    } else if (status === 404) {
      const _responseText = response.data;
      let result404: any = null;
      let resultData404 = _responseText;
      result404 = ProblemDetails.fromJS(resultData404);
      return throwException(
        "Profile/Minority Status/Type not found.",
        status,
        _responseText,
        _headers,
        result404
      );
    } else if (status === 401) {
      const _responseText = response.data;
      return throwException("Unauthorized", status, _responseText, _headers);
    } else if (status === 403) {
      const _responseText = response.data;
      return throwException("Forbidden", status, _responseText, _headers);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<void>(<any>null);
  }

  /**
   * Deletes the specified product, scoped to the company/business unit of the current user.
   * @param x_Requested_Business_Unit_Id (optional)
   * @return Successfully deleted product.
   */
  deleteProfileProduct(
    id: string,
    x_Requested_Business_Unit_Id?: any | undefined,
    cancelToken?: CancelToken | undefined
  ): Promise<void> {
    let url_ = this.baseUrl + "/api/v1/profiles/products/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_ = <AxiosRequestConfig>{
      method: "DELETE",
      url: url_,
      headers: {
        "X-Requested-Business-Unit-Id":
          x_Requested_Business_Unit_Id !== undefined &&
          x_Requested_Business_Unit_Id !== null
            ? "" + x_Requested_Business_Unit_Id
            : ""
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processDeleteProfileProduct(_response);
      });
  }

  protected processDeleteProfileProduct(
    response: AxiosResponse
  ): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 204) {
      const _responseText = response.data;
      return Promise.resolve<void>(<any>null);
    } else if (status === 404) {
      const _responseText = response.data;
      let result404: any = null;
      let resultData404 = _responseText;
      result404 = ProblemDetails.fromJS(resultData404);
      return throwException(
        "Profile/Product not found.",
        status,
        _responseText,
        _headers,
        result404
      );
    } else if (status === 401) {
      const _responseText = response.data;
      return throwException("Unauthorized", status, _responseText, _headers);
    } else if (status === 403) {
      const _responseText = response.data;
      return throwException("Forbidden", status, _responseText, _headers);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<void>(<any>null);
  }

  /**
   * Updates the specified product, scoped to the company/business unit of the current user.
   * @param x_Requested_Business_Unit_Id (optional)
   * @param body (optional)
   * @return Successfully updated product.
   */
  updateProfileProduct(
    id: string,
    x_Requested_Business_Unit_Id?: any | undefined,
    body?: UpdateProfileProductDto | undefined,
    cancelToken?: CancelToken | undefined
  ): Promise<void> {
    let url_ = this.baseUrl + "/api/v1/profiles/products/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_ = <AxiosRequestConfig>{
      data: content_,
      method: "PUT",
      url: url_,
      headers: {
        "X-Requested-Business-Unit-Id":
          x_Requested_Business_Unit_Id !== undefined &&
          x_Requested_Business_Unit_Id !== null
            ? "" + x_Requested_Business_Unit_Id
            : "",
        "Content-Type": "application/json"
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processUpdateProfileProduct(_response);
      });
  }

  protected processUpdateProfileProduct(
    response: AxiosResponse
  ): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 204) {
      const _responseText = response.data;
      return Promise.resolve<void>(<any>null);
    } else if (status === 404) {
      const _responseText = response.data;
      let result404: any = null;
      let resultData404 = _responseText;
      result404 = ProblemDetails.fromJS(resultData404);
      return throwException(
        "Profile/Product not found.",
        status,
        _responseText,
        _headers,
        result404
      );
    } else if (status === 401) {
      const _responseText = response.data;
      return throwException("Unauthorized", status, _responseText, _headers);
    } else if (status === 403) {
      const _responseText = response.data;
      return throwException("Forbidden", status, _responseText, _headers);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<void>(<any>null);
  }

  /**
   * Deletes an existing region, scoped to the company/business unit of the current user.
   * @param id The region's unique identifier.
   * @param x_Requested_Business_Unit_Id (optional)
   * @return Region deleted.
   */
  deleteRegion(
    id: string,
    x_Requested_Business_Unit_Id?: any | undefined,
    cancelToken?: CancelToken | undefined
  ): Promise<void> {
    let url_ = this.baseUrl + "/api/v1/regions/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_ = <AxiosRequestConfig>{
      method: "DELETE",
      url: url_,
      headers: {
        "X-Requested-Business-Unit-Id":
          x_Requested_Business_Unit_Id !== undefined &&
          x_Requested_Business_Unit_Id !== null
            ? "" + x_Requested_Business_Unit_Id
            : ""
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processDeleteRegion(_response);
      });
  }

  protected processDeleteRegion(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 204) {
      const _responseText = response.data;
      return Promise.resolve<void>(<any>null);
    } else if (status === 404) {
      const _responseText = response.data;
      let result404: any = null;
      let resultData404 = _responseText;
      result404 = ProblemDetails.fromJS(resultData404);
      return throwException(
        "Region not found.",
        status,
        _responseText,
        _headers,
        result404
      );
    } else if (status === 401) {
      const _responseText = response.data;
      return throwException("Unauthorized", status, _responseText, _headers);
    } else if (status === 403) {
      const _responseText = response.data;
      return throwException("Forbidden", status, _responseText, _headers);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<void>(<any>null);
  }

  /**
     * Returns the region specified by the unique identifier,
    scoped to the company/business unit of the current user.
     * @param id The Region's unique identifier.
     * @param x_Requested_Business_Unit_Id (optional) 
     * @return Success
     */
  getRegion(
    id: string,
    x_Requested_Business_Unit_Id?: any | undefined,
    cancelToken?: CancelToken | undefined
  ): Promise<RegionDto> {
    let url_ = this.baseUrl + "/api/v1/regions/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_ = <AxiosRequestConfig>{
      method: "GET",
      url: url_,
      headers: {
        "X-Requested-Business-Unit-Id":
          x_Requested_Business_Unit_Id !== undefined &&
          x_Requested_Business_Unit_Id !== null
            ? "" + x_Requested_Business_Unit_Id
            : "",
        Accept: "application/json"
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetRegion(_response);
      });
  }

  protected processGetRegion(response: AxiosResponse): Promise<RegionDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = RegionDto.fromJS(resultData200);
      return result200;
    } else if (status === 404) {
      const _responseText = response.data;
      let result404: any = null;
      let resultData404 = _responseText;
      result404 = ProblemDetails.fromJS(resultData404);
      return throwException(
        "Region not found.",
        status,
        _responseText,
        _headers,
        result404
      );
    } else if (status === 401) {
      const _responseText = response.data;
      return throwException("Unauthorized", status, _responseText, _headers);
    } else if (status === 403) {
      const _responseText = response.data;
      return throwException("Forbidden", status, _responseText, _headers);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<RegionDto>(<any>null);
  }

  /**
   * Updates an existing region, scoped to the company/business unit of the current user.
   * @param x_Requested_Business_Unit_Id (optional)
   * @param body (optional)
   * @return Region updated.
   */
  updateRegion(
    id: string,
    x_Requested_Business_Unit_Id?: any | undefined,
    body?: UpdateRegionDto | undefined,
    cancelToken?: CancelToken | undefined
  ): Promise<void> {
    let url_ = this.baseUrl + "/api/v1/regions/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_ = <AxiosRequestConfig>{
      data: content_,
      method: "PUT",
      url: url_,
      headers: {
        "X-Requested-Business-Unit-Id":
          x_Requested_Business_Unit_Id !== undefined &&
          x_Requested_Business_Unit_Id !== null
            ? "" + x_Requested_Business_Unit_Id
            : "",
        "Content-Type": "application/json"
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processUpdateRegion(_response);
      });
  }

  protected processUpdateRegion(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 204) {
      const _responseText = response.data;
      return Promise.resolve<void>(<any>null);
    } else if (status === 409) {
      const _responseText = response.data;
      let result409: any = null;
      let resultData409 = _responseText;
      result409 = ProblemDetails.fromJS(resultData409);
      return throwException(
        "Region code already in use.",
        status,
        _responseText,
        _headers,
        result409
      );
    } else if (status === 404) {
      const _responseText = response.data;
      let result404: any = null;
      let resultData404 = _responseText;
      result404 = ProblemDetails.fromJS(resultData404);
      return throwException(
        "Region not found.",
        status,
        _responseText,
        _headers,
        result404
      );
    } else if (status === 401) {
      const _responseText = response.data;
      return throwException("Unauthorized", status, _responseText, _headers);
    } else if (status === 403) {
      const _responseText = response.data;
      return throwException("Forbidden", status, _responseText, _headers);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<void>(<any>null);
  }

  /**
   * Deletes an existing vendor, scoped to the company/business unit of the current user.
   * @param x_Requested_Business_Unit_Id (optional)
   * @return Success
   */
  deleteVendor(
    id: string,
    x_Requested_Business_Unit_Id?: any | undefined,
    cancelToken?: CancelToken | undefined
  ): Promise<void> {
    let url_ = this.baseUrl + "/api/v1/vendors/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_ = <AxiosRequestConfig>{
      method: "DELETE",
      url: url_,
      headers: {
        "X-Requested-Business-Unit-Id":
          x_Requested_Business_Unit_Id !== undefined &&
          x_Requested_Business_Unit_Id !== null
            ? "" + x_Requested_Business_Unit_Id
            : ""
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processDeleteVendor(_response);
      });
  }

  protected processDeleteVendor(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      return Promise.resolve<void>(<any>null);
    } else if (status === 204) {
      const _responseText = response.data;
      return Promise.resolve<void>(<any>null);
    } else if (status === 404) {
      const _responseText = response.data;
      return throwException(
        "Vendor not found.",
        status,
        _responseText,
        _headers
      );
    } else if (status === 401) {
      const _responseText = response.data;
      return throwException("Unauthorized", status, _responseText, _headers);
    } else if (status === 403) {
      const _responseText = response.data;
      return throwException("Forbidden", status, _responseText, _headers);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<void>(<any>null);
  }

  /**
     * Returns the vendor specified by the unique identifier,
    scoped to the company/business unit of the current user.
     * @param x_Requested_Business_Unit_Id (optional) 
     * @return Success
     * @deprecated
     */
  getVendor(
    id: string,
    x_Requested_Business_Unit_Id?: any | undefined,
    cancelToken?: CancelToken | undefined
  ): Promise<VendorDtoV1Response> {
    let url_ = this.baseUrl + "/api/v1/vendors/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_ = <AxiosRequestConfig>{
      method: "GET",
      url: url_,
      headers: {
        "X-Requested-Business-Unit-Id":
          x_Requested_Business_Unit_Id !== undefined &&
          x_Requested_Business_Unit_Id !== null
            ? "" + x_Requested_Business_Unit_Id
            : "",
        Accept: "application/json"
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetVendor(_response);
      });
  }

  protected processGetVendor(
    response: AxiosResponse
  ): Promise<VendorDtoV1Response> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = VendorDtoV1Response.fromJS(resultData200);
      return result200;
    } else if (status === 404) {
      const _responseText = response.data;
      return throwException(
        "Vendor not found",
        status,
        _responseText,
        _headers
      );
    } else if (status === 401) {
      const _responseText = response.data;
      return throwException("Unauthorized", status, _responseText, _headers);
    } else if (status === 403) {
      const _responseText = response.data;
      return throwException("Forbidden", status, _responseText, _headers);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<VendorDtoV1Response>(<any>null);
  }

  /**
   * Updates an existing vendor, scoped to the company/business unit of the current user.
   * @param x_Requested_Business_Unit_Id (optional)
   * @param body (optional)
   * @return Successfully updated the vendor.
   * @deprecated
   */
  updateVendor(
    id: string,
    x_Requested_Business_Unit_Id?: any | undefined,
    body?: UpdateVendorDto | undefined,
    cancelToken?: CancelToken | undefined
  ): Promise<void> {
    let url_ = this.baseUrl + "/api/v1/vendors/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_ = <AxiosRequestConfig>{
      data: content_,
      method: "PUT",
      url: url_,
      headers: {
        "X-Requested-Business-Unit-Id":
          x_Requested_Business_Unit_Id !== undefined &&
          x_Requested_Business_Unit_Id !== null
            ? "" + x_Requested_Business_Unit_Id
            : "",
        "Content-Type": "application/json"
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processUpdateVendor(_response);
      });
  }

  protected processUpdateVendor(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 204) {
      const _responseText = response.data;
      return Promise.resolve<void>(<any>null);
    } else if (status === 404) {
      const _responseText = response.data;
      let result404: any = null;
      let resultData404 = _responseText;
      result404 = ProblemDetails.fromJS(resultData404);
      return throwException(
        "Vendor/Region not found.",
        status,
        _responseText,
        _headers,
        result404
      );
    } else if (status === 409) {
      const _responseText = response.data;
      let result409: any = null;
      let resultData409 = _responseText;
      result409 = ProblemDetails.fromJS(resultData409);
      return throwException(
        "Vendor code already exists.",
        status,
        _responseText,
        _headers,
        result409
      );
    } else if (status === 401) {
      const _responseText = response.data;
      return throwException("Unauthorized", status, _responseText, _headers);
    } else if (status === 403) {
      const _responseText = response.data;
      return throwException("Forbidden", status, _responseText, _headers);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<void>(<any>null);
  }

  /**
   * Deletes the specified contact, scoped to the company/business unit of the current user.
   * @param x_Requested_Business_Unit_Id (optional)
   * @return Successfully deleted contact.
   */
  deleteVendorContact(
    vendorId: string,
    contactId: string,
    x_Requested_Business_Unit_Id?: any | undefined,
    cancelToken?: CancelToken | undefined
  ): Promise<void> {
    let url_ = this.baseUrl + "/api/v1/vendors/{vendorId}/contacts/{contactId}";
    if (vendorId === undefined || vendorId === null)
      throw new Error("The parameter 'vendorId' must be defined.");
    url_ = url_.replace("{vendorId}", encodeURIComponent("" + vendorId));
    if (contactId === undefined || contactId === null)
      throw new Error("The parameter 'contactId' must be defined.");
    url_ = url_.replace("{contactId}", encodeURIComponent("" + contactId));
    url_ = url_.replace(/[?&]$/, "");

    let options_ = <AxiosRequestConfig>{
      method: "DELETE",
      url: url_,
      headers: {
        "X-Requested-Business-Unit-Id":
          x_Requested_Business_Unit_Id !== undefined &&
          x_Requested_Business_Unit_Id !== null
            ? "" + x_Requested_Business_Unit_Id
            : ""
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processDeleteVendorContact(_response);
      });
  }

  protected processDeleteVendorContact(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 204) {
      const _responseText = response.data;
      return Promise.resolve<void>(<any>null);
    } else if (status === 404) {
      const _responseText = response.data;
      let result404: any = null;
      let resultData404 = _responseText;
      result404 = ProblemDetails.fromJS(resultData404);
      return throwException(
        "Vendor/Contact not found.",
        status,
        _responseText,
        _headers,
        result404
      );
    } else if (status === 401) {
      const _responseText = response.data;
      return throwException("Unauthorized", status, _responseText, _headers);
    } else if (status === 403) {
      const _responseText = response.data;
      return throwException("Forbidden", status, _responseText, _headers);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<void>(<any>null);
  }

  /**
   * Updates the specified contact, scoped to the company/business unit of the current user.
   * @param x_Requested_Business_Unit_Id (optional)
   * @param body (optional)
   * @return Successfully updated contact.
   */
  updateVendorContact(
    vendorId: string,
    contactId: string,
    x_Requested_Business_Unit_Id?: any | undefined,
    body?: UpdateVendorContactDto | undefined,
    cancelToken?: CancelToken | undefined
  ): Promise<void> {
    let url_ = this.baseUrl + "/api/v1/vendors/{vendorId}/contacts/{contactId}";
    if (vendorId === undefined || vendorId === null)
      throw new Error("The parameter 'vendorId' must be defined.");
    url_ = url_.replace("{vendorId}", encodeURIComponent("" + vendorId));
    if (contactId === undefined || contactId === null)
      throw new Error("The parameter 'contactId' must be defined.");
    url_ = url_.replace("{contactId}", encodeURIComponent("" + contactId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_ = <AxiosRequestConfig>{
      data: content_,
      method: "PUT",
      url: url_,
      headers: {
        "X-Requested-Business-Unit-Id":
          x_Requested_Business_Unit_Id !== undefined &&
          x_Requested_Business_Unit_Id !== null
            ? "" + x_Requested_Business_Unit_Id
            : "",
        "Content-Type": "application/json"
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processUpdateVendorContact(_response);
      });
  }

  protected processUpdateVendorContact(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 204) {
      const _responseText = response.data;
      return Promise.resolve<void>(<any>null);
    } else if (status === 404) {
      const _responseText = response.data;
      let result404: any = null;
      let resultData404 = _responseText;
      result404 = ProblemDetails.fromJS(resultData404);
      return throwException(
        "Vendor/Contact not found.",
        status,
        _responseText,
        _headers,
        result404
      );
    } else if (status === 401) {
      const _responseText = response.data;
      return throwException("Unauthorized", status, _responseText, _headers);
    } else if (status === 403) {
      const _responseText = response.data;
      return throwException("Forbidden", status, _responseText, _headers);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<void>(<any>null);
  }

  /**
   * Deletes the specified minority status, scoped to the company/business unit of the current user.
   * @param x_Requested_Business_Unit_Id (optional)
   * @return Successfully deleted minority status.
   */
  deleteVendorMinorityStatus(
    vendorId: string,
    statusId: string,
    x_Requested_Business_Unit_Id?: any | undefined,
    cancelToken?: CancelToken | undefined
  ): Promise<void> {
    let url_ = this.baseUrl + "/api/v1/vendors/{vendorId}/statuses/{statusId}";
    if (vendorId === undefined || vendorId === null)
      throw new Error("The parameter 'vendorId' must be defined.");
    url_ = url_.replace("{vendorId}", encodeURIComponent("" + vendorId));
    if (statusId === undefined || statusId === null)
      throw new Error("The parameter 'statusId' must be defined.");
    url_ = url_.replace("{statusId}", encodeURIComponent("" + statusId));
    url_ = url_.replace(/[?&]$/, "");

    let options_ = <AxiosRequestConfig>{
      method: "DELETE",
      url: url_,
      headers: {
        "X-Requested-Business-Unit-Id":
          x_Requested_Business_Unit_Id !== undefined &&
          x_Requested_Business_Unit_Id !== null
            ? "" + x_Requested_Business_Unit_Id
            : ""
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processDeleteVendorMinorityStatus(_response);
      });
  }

  protected processDeleteVendorMinorityStatus(
    response: AxiosResponse
  ): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 204) {
      const _responseText = response.data;
      return Promise.resolve<void>(<any>null);
    } else if (status === 404) {
      const _responseText = response.data;
      let result404: any = null;
      let resultData404 = _responseText;
      result404 = ProblemDetails.fromJS(resultData404);
      return throwException(
        "Vendor/Minority status not found.",
        status,
        _responseText,
        _headers,
        result404
      );
    } else if (status === 401) {
      const _responseText = response.data;
      return throwException("Unauthorized", status, _responseText, _headers);
    } else if (status === 403) {
      const _responseText = response.data;
      return throwException("Forbidden", status, _responseText, _headers);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<void>(<any>null);
  }

  /**
   * Updates the specified minority status, scoped to the company/business unit of the current user.
   * @param x_Requested_Business_Unit_Id (optional)
   * @param body (optional)
   * @return Successfully updated minority status.
   */
  updateVendorMinorityStatus(
    vendorId: string,
    statusId: string,
    x_Requested_Business_Unit_Id?: any | undefined,
    body?: UpdateVendorMinorityStatusDto | undefined,
    cancelToken?: CancelToken | undefined
  ): Promise<void> {
    let url_ = this.baseUrl + "/api/v1/vendors/{vendorId}/statuses/{statusId}";
    if (vendorId === undefined || vendorId === null)
      throw new Error("The parameter 'vendorId' must be defined.");
    url_ = url_.replace("{vendorId}", encodeURIComponent("" + vendorId));
    if (statusId === undefined || statusId === null)
      throw new Error("The parameter 'statusId' must be defined.");
    url_ = url_.replace("{statusId}", encodeURIComponent("" + statusId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_ = <AxiosRequestConfig>{
      data: content_,
      method: "PUT",
      url: url_,
      headers: {
        "X-Requested-Business-Unit-Id":
          x_Requested_Business_Unit_Id !== undefined &&
          x_Requested_Business_Unit_Id !== null
            ? "" + x_Requested_Business_Unit_Id
            : "",
        "Content-Type": "application/json"
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processUpdateVendorMinorityStatus(_response);
      });
  }

  protected processUpdateVendorMinorityStatus(
    response: AxiosResponse
  ): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 204) {
      const _responseText = response.data;
      return Promise.resolve<void>(<any>null);
    } else if (status === 404) {
      const _responseText = response.data;
      let result404: any = null;
      let resultData404 = _responseText;
      result404 = ProblemDetails.fromJS(resultData404);
      return throwException(
        "Vendor/Minority status not found.",
        status,
        _responseText,
        _headers,
        result404
      );
    } else if (status === 401) {
      const _responseText = response.data;
      return throwException("Unauthorized", status, _responseText, _headers);
    } else if (status === 403) {
      const _responseText = response.data;
      return throwException("Forbidden", status, _responseText, _headers);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<void>(<any>null);
  }

  /**
   * Deletes the specified product, scoped to the company/business unit of the current user.
   * @param x_Requested_Business_Unit_Id (optional)
   * @return Successfully deleted product.
   */
  deleteVendorProduct(
    vendorId: string,
    productId: string,
    x_Requested_Business_Unit_Id?: any | undefined,
    cancelToken?: CancelToken | undefined
  ): Promise<void> {
    let url_ = this.baseUrl + "/api/v1/vendors/{vendorId}/products/{productId}";
    if (vendorId === undefined || vendorId === null)
      throw new Error("The parameter 'vendorId' must be defined.");
    url_ = url_.replace("{vendorId}", encodeURIComponent("" + vendorId));
    if (productId === undefined || productId === null)
      throw new Error("The parameter 'productId' must be defined.");
    url_ = url_.replace("{productId}", encodeURIComponent("" + productId));
    url_ = url_.replace(/[?&]$/, "");

    let options_ = <AxiosRequestConfig>{
      method: "DELETE",
      url: url_,
      headers: {
        "X-Requested-Business-Unit-Id":
          x_Requested_Business_Unit_Id !== undefined &&
          x_Requested_Business_Unit_Id !== null
            ? "" + x_Requested_Business_Unit_Id
            : ""
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processDeleteVendorProduct(_response);
      });
  }

  protected processDeleteVendorProduct(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 204) {
      const _responseText = response.data;
      return Promise.resolve<void>(<any>null);
    } else if (status === 404) {
      const _responseText = response.data;
      let result404: any = null;
      let resultData404 = _responseText;
      result404 = ProblemDetails.fromJS(resultData404);
      return throwException(
        "Vendor/Product not found.",
        status,
        _responseText,
        _headers,
        result404
      );
    } else if (status === 401) {
      const _responseText = response.data;
      return throwException("Unauthorized", status, _responseText, _headers);
    } else if (status === 403) {
      const _responseText = response.data;
      return throwException("Forbidden", status, _responseText, _headers);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<void>(<any>null);
  }

  /**
   * Updates the specified product, scoped to the company/business unit of the current user.
   * @param x_Requested_Business_Unit_Id (optional)
   * @param body (optional)
   * @return Successfully updated product.
   */
  updateVendorProduct(
    vendorId: string,
    productId: string,
    x_Requested_Business_Unit_Id?: any | undefined,
    body?: UpdateVendorProductDto | undefined,
    cancelToken?: CancelToken | undefined
  ): Promise<void> {
    let url_ = this.baseUrl + "/api/v1/vendors/{vendorId}/products/{productId}";
    if (vendorId === undefined || vendorId === null)
      throw new Error("The parameter 'vendorId' must be defined.");
    url_ = url_.replace("{vendorId}", encodeURIComponent("" + vendorId));
    if (productId === undefined || productId === null)
      throw new Error("The parameter 'productId' must be defined.");
    url_ = url_.replace("{productId}", encodeURIComponent("" + productId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_ = <AxiosRequestConfig>{
      data: content_,
      method: "PUT",
      url: url_,
      headers: {
        "X-Requested-Business-Unit-Id":
          x_Requested_Business_Unit_Id !== undefined &&
          x_Requested_Business_Unit_Id !== null
            ? "" + x_Requested_Business_Unit_Id
            : "",
        "Content-Type": "application/json"
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processUpdateVendorProduct(_response);
      });
  }

  protected processUpdateVendorProduct(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 204) {
      const _responseText = response.data;
      return Promise.resolve<void>(<any>null);
    } else if (status === 404) {
      const _responseText = response.data;
      let result404: any = null;
      let resultData404 = _responseText;
      result404 = ProblemDetails.fromJS(resultData404);
      return throwException(
        "Vendor/Product not found.",
        status,
        _responseText,
        _headers,
        result404
      );
    } else if (status === 401) {
      const _responseText = response.data;
      return throwException("Unauthorized", status, _responseText, _headers);
    } else if (status === 403) {
      const _responseText = response.data;
      return throwException("Forbidden", status, _responseText, _headers);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<void>(<any>null);
  }

  /**
   * Returns all company types, scoped to the company/business unit of the current user.
   * @param x_Requested_Business_Unit_Id (optional)
   * @return Success
   */
  getCompanyTypes(
    x_Requested_Business_Unit_Id?: any | undefined,
    cancelToken?: CancelToken | undefined
  ): Promise<CompanyTypeDto[]> {
    let url_ = this.baseUrl + "/api/v1/companyTypes";
    url_ = url_.replace(/[?&]$/, "");

    let options_ = <AxiosRequestConfig>{
      method: "GET",
      url: url_,
      headers: {
        "X-Requested-Business-Unit-Id":
          x_Requested_Business_Unit_Id !== undefined &&
          x_Requested_Business_Unit_Id !== null
            ? "" + x_Requested_Business_Unit_Id
            : "",
        Accept: "application/json"
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetCompanyTypes(_response);
      });
  }

  protected processGetCompanyTypes(
    response: AxiosResponse
  ): Promise<CompanyTypeDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      if (Array.isArray(resultData200)) {
        result200 = [] as any;
        for (let item of resultData200)
          result200!.push(CompanyTypeDto.fromJS(item));
      }
      return result200;
    } else if (status === 401) {
      const _responseText = response.data;
      return throwException("Unauthorized", status, _responseText, _headers);
    } else if (status === 403) {
      const _responseText = response.data;
      return throwException("Forbidden", status, _responseText, _headers);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<CompanyTypeDto[]>(<any>null);
  }

  /**
   * Creates a new company type, scoped to the company/business unit of the current user.
   * @param x_Requested_Business_Unit_Id (optional)
   * @param body (optional) The new company type
   * @return Company type created.
   */
  createCompanyType(
    x_Requested_Business_Unit_Id?: any | undefined,
    body?: CreateCompanyTypeDto | undefined,
    cancelToken?: CancelToken | undefined
  ): Promise<string> {
    let url_ = this.baseUrl + "/api/v1/companyTypes";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_ = <AxiosRequestConfig>{
      data: content_,
      method: "POST",
      url: url_,
      headers: {
        "X-Requested-Business-Unit-Id":
          x_Requested_Business_Unit_Id !== undefined &&
          x_Requested_Business_Unit_Id !== null
            ? "" + x_Requested_Business_Unit_Id
            : "",
        "Content-Type": "application/json",
        Accept: "application/json"
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processCreateCompanyType(_response);
      });
  }

  protected processCreateCompanyType(response: AxiosResponse): Promise<string> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 201) {
      const _responseText = response.data;
      let result201: any = null;
      let resultData201 = _responseText;
      result201 = resultData201 !== undefined ? resultData201 : <any>null;
      return result201;
    } else if (status === 409) {
      const _responseText = response.data;
      let result409: any = null;
      let resultData409 = _responseText;
      result409 = ProblemDetails.fromJS(resultData409);
      return throwException(
        "Company type Code already in use.",
        status,
        _responseText,
        _headers,
        result409
      );
    } else if (status === 401) {
      const _responseText = response.data;
      return throwException("Unauthorized", status, _responseText, _headers);
    } else if (status === 403) {
      const _responseText = response.data;
      return throwException("Forbidden", status, _responseText, _headers);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<string>(<any>null);
  }

  /**
   * Return all contacts scoped to the company/business unit of the current user.
   * @param x_Requested_Business_Unit_Id (optional)
   * @return Success
   */
  getContacts(
    x_Requested_Business_Unit_Id?: any | undefined,
    cancelToken?: CancelToken | undefined
  ): Promise<GetContactDto[]> {
    let url_ = this.baseUrl + "/api/v1/contacts";
    url_ = url_.replace(/[?&]$/, "");

    let options_ = <AxiosRequestConfig>{
      method: "GET",
      url: url_,
      headers: {
        "X-Requested-Business-Unit-Id":
          x_Requested_Business_Unit_Id !== undefined &&
          x_Requested_Business_Unit_Id !== null
            ? "" + x_Requested_Business_Unit_Id
            : "",
        Accept: "application/json"
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetContacts(_response);
      });
  }

  protected processGetContacts(
    response: AxiosResponse
  ): Promise<GetContactDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      if (Array.isArray(resultData200)) {
        result200 = [] as any;
        for (let item of resultData200)
          result200!.push(GetContactDto.fromJS(item));
      }
      return result200;
    } else if (status === 404) {
      const _responseText = response.data;
      return throwException(
        "Contact not found",
        status,
        _responseText,
        _headers
      );
    } else if (status === 401) {
      const _responseText = response.data;
      return throwException("Unauthorized", status, _responseText, _headers);
    } else if (status === 403) {
      const _responseText = response.data;
      return throwException("Forbidden", status, _responseText, _headers);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<GetContactDto[]>(<any>null);
  }

  /**
     * Return all contacts scoped to the company/business unit of the current user based on a search term. 
    Currently the search term will do a "starts with" comparison against contact first name, last name
    phone and email. It will also search the company code and name that each contact belongs to.
     * @param filter (optional) The search term
     * @param x_Requested_Business_Unit_Id (optional) 
     * @return Success
     */
  getContactsSearch(
    filter?: string | null | undefined,
    x_Requested_Business_Unit_Id?: any | undefined,
    cancelToken?: CancelToken | undefined
  ): Promise<GetContactSearchDto[]> {
    let url_ = this.baseUrl + "/api/v1/contacts/search?";
    if (filter !== undefined && filter !== null)
      url_ += "filter=" + encodeURIComponent("" + filter) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_ = <AxiosRequestConfig>{
      method: "GET",
      url: url_,
      headers: {
        "X-Requested-Business-Unit-Id":
          x_Requested_Business_Unit_Id !== undefined &&
          x_Requested_Business_Unit_Id !== null
            ? "" + x_Requested_Business_Unit_Id
            : "",
        Accept: "application/json"
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetContactsSearch(_response);
      });
  }

  protected processGetContactsSearch(
    response: AxiosResponse
  ): Promise<GetContactSearchDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      if (Array.isArray(resultData200)) {
        result200 = [] as any;
        for (let item of resultData200)
          result200!.push(GetContactSearchDto.fromJS(item));
      }
      return result200;
    } else if (status === 401) {
      const _responseText = response.data;
      return throwException("Unauthorized", status, _responseText, _headers);
    } else if (status === 403) {
      const _responseText = response.data;
      return throwException("Forbidden", status, _responseText, _headers);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<GetContactSearchDto[]>(<any>null);
  }

  /**
   * Returns all minority types, scoped to the company/business unit of the current user.
   * @param x_Requested_Business_Unit_Id (optional)
   * @return Success
   */
  getMinorityTypes(
    x_Requested_Business_Unit_Id?: any | undefined,
    cancelToken?: CancelToken | undefined
  ): Promise<MinorityTypeDto[]> {
    let url_ = this.baseUrl + "/api/v1/minorityTypes";
    url_ = url_.replace(/[?&]$/, "");

    let options_ = <AxiosRequestConfig>{
      method: "GET",
      url: url_,
      headers: {
        "X-Requested-Business-Unit-Id":
          x_Requested_Business_Unit_Id !== undefined &&
          x_Requested_Business_Unit_Id !== null
            ? "" + x_Requested_Business_Unit_Id
            : "",
        Accept: "application/json"
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetMinorityTypes(_response);
      });
  }

  protected processGetMinorityTypes(
    response: AxiosResponse
  ): Promise<MinorityTypeDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      if (Array.isArray(resultData200)) {
        result200 = [] as any;
        for (let item of resultData200)
          result200!.push(MinorityTypeDto.fromJS(item));
      }
      return result200;
    } else if (status === 401) {
      const _responseText = response.data;
      return throwException("Unauthorized", status, _responseText, _headers);
    } else if (status === 403) {
      const _responseText = response.data;
      return throwException("Forbidden", status, _responseText, _headers);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<MinorityTypeDto[]>(<any>null);
  }

  /**
   * Creates a new minority type, scoped to the company/business unit of the current user.
   * @param x_Requested_Business_Unit_Id (optional)
   * @param body (optional)
   * @return Minority type created.
   */
  createMinorityType(
    x_Requested_Business_Unit_Id?: any | undefined,
    body?: CreateMinorityTypeDto | undefined,
    cancelToken?: CancelToken | undefined
  ): Promise<string> {
    let url_ = this.baseUrl + "/api/v1/minorityTypes";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_ = <AxiosRequestConfig>{
      data: content_,
      method: "POST",
      url: url_,
      headers: {
        "X-Requested-Business-Unit-Id":
          x_Requested_Business_Unit_Id !== undefined &&
          x_Requested_Business_Unit_Id !== null
            ? "" + x_Requested_Business_Unit_Id
            : "",
        "Content-Type": "application/json",
        Accept: "application/json"
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processCreateMinorityType(_response);
      });
  }

  protected processCreateMinorityType(
    response: AxiosResponse
  ): Promise<string> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 201) {
      const _responseText = response.data;
      let result201: any = null;
      let resultData201 = _responseText;
      result201 = resultData201 !== undefined ? resultData201 : <any>null;
      return result201;
    } else if (status === 409) {
      const _responseText = response.data;
      let result409: any = null;
      let resultData409 = _responseText;
      result409 = ProblemDetails.fromJS(resultData409);
      return throwException(
        "Minority type code already in use.",
        status,
        _responseText,
        _headers,
        result409
      );
    } else if (status === 401) {
      const _responseText = response.data;
      return throwException("Unauthorized", status, _responseText, _headers);
    } else if (status === 403) {
      const _responseText = response.data;
      return throwException("Forbidden", status, _responseText, _headers);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<string>(<any>null);
  }

  /**
   * Returns all product types, scoped to the company/business unit of the current user.
   * @param x_Requested_Business_Unit_Id (optional)
   * @return Success
   */
  getProductTypes(
    x_Requested_Business_Unit_Id?: any | undefined,
    cancelToken?: CancelToken | undefined
  ): Promise<ProductTypeDto[]> {
    let url_ = this.baseUrl + "/api/v1/productTypes";
    url_ = url_.replace(/[?&]$/, "");

    let options_ = <AxiosRequestConfig>{
      method: "GET",
      url: url_,
      headers: {
        "X-Requested-Business-Unit-Id":
          x_Requested_Business_Unit_Id !== undefined &&
          x_Requested_Business_Unit_Id !== null
            ? "" + x_Requested_Business_Unit_Id
            : "",
        Accept: "application/json"
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetProductTypes(_response);
      });
  }

  protected processGetProductTypes(
    response: AxiosResponse
  ): Promise<ProductTypeDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      if (Array.isArray(resultData200)) {
        result200 = [] as any;
        for (let item of resultData200)
          result200!.push(ProductTypeDto.fromJS(item));
      }
      return result200;
    } else if (status === 401) {
      const _responseText = response.data;
      return throwException("Unauthorized", status, _responseText, _headers);
    } else if (status === 403) {
      const _responseText = response.data;
      return throwException("Forbidden", status, _responseText, _headers);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<ProductTypeDto[]>(<any>null);
  }

  /**
   * Creates a new product type, scoped to the company/business unit of the current user.
   * @param x_Requested_Business_Unit_Id (optional)
   * @param body (optional)
   * @return Product type created.
   */
  createProductType(
    x_Requested_Business_Unit_Id?: any | undefined,
    body?: CreateProductTypeDto | undefined,
    cancelToken?: CancelToken | undefined
  ): Promise<string> {
    let url_ = this.baseUrl + "/api/v1/productTypes";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_ = <AxiosRequestConfig>{
      data: content_,
      method: "POST",
      url: url_,
      headers: {
        "X-Requested-Business-Unit-Id":
          x_Requested_Business_Unit_Id !== undefined &&
          x_Requested_Business_Unit_Id !== null
            ? "" + x_Requested_Business_Unit_Id
            : "",
        "Content-Type": "application/json",
        Accept: "application/json"
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processCreateProductType(_response);
      });
  }

  protected processCreateProductType(response: AxiosResponse): Promise<string> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 201) {
      const _responseText = response.data;
      let result201: any = null;
      let resultData201 = _responseText;
      result201 = resultData201 !== undefined ? resultData201 : <any>null;
      return result201;
    } else if (status === 409) {
      const _responseText = response.data;
      let result409: any = null;
      let resultData409 = _responseText;
      result409 = ProblemDetails.fromJS(resultData409);
      return throwException(
        "Product type code already in use.",
        status,
        _responseText,
        _headers,
        result409
      );
    } else if (status === 401) {
      const _responseText = response.data;
      return throwException("Unauthorized", status, _responseText, _headers);
    } else if (status === 403) {
      const _responseText = response.data;
      return throwException("Forbidden", status, _responseText, _headers);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<string>(<any>null);
  }

  /**
   * Returns the profile for the current authenticated user's company/business unit.
   * @param x_Requested_Business_Unit_Id (optional)
   * @return Success
   */
  getMyProfile(
    x_Requested_Business_Unit_Id?: any | undefined,
    cancelToken?: CancelToken | undefined
  ): Promise<ProfileDto> {
    let url_ = this.baseUrl + "/api/v1/profiles/me";
    url_ = url_.replace(/[?&]$/, "");

    let options_ = <AxiosRequestConfig>{
      method: "GET",
      url: url_,
      headers: {
        "X-Requested-Business-Unit-Id":
          x_Requested_Business_Unit_Id !== undefined &&
          x_Requested_Business_Unit_Id !== null
            ? "" + x_Requested_Business_Unit_Id
            : "",
        Accept: "application/json"
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetMyProfile(_response);
      });
  }

  protected processGetMyProfile(response: AxiosResponse): Promise<ProfileDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = ProfileDto.fromJS(resultData200);
      return result200;
    } else if (status === 404) {
      const _responseText = response.data;
      let result404: any = null;
      let resultData404 = _responseText;
      result404 = ProblemDetails.fromJS(resultData404);
      return throwException(
        "Profile not found",
        status,
        _responseText,
        _headers,
        result404
      );
    } else if (status === 401) {
      const _responseText = response.data;
      return throwException("Unauthorized", status, _responseText, _headers);
    } else if (status === 403) {
      const _responseText = response.data;
      return throwException("Forbidden", status, _responseText, _headers);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<ProfileDto>(<any>null);
  }

  /**
   * Returns all profiles.
   * @param x_Requested_Business_Unit_Id (optional)
   * @return Success
   */
  getProfiles(
    x_Requested_Business_Unit_Id?: any | undefined,
    cancelToken?: CancelToken | undefined
  ): Promise<ProfileSummaryDto[]> {
    let url_ = this.baseUrl + "/api/v1/profiles";
    url_ = url_.replace(/[?&]$/, "");

    let options_ = <AxiosRequestConfig>{
      method: "GET",
      url: url_,
      headers: {
        "X-Requested-Business-Unit-Id":
          x_Requested_Business_Unit_Id !== undefined &&
          x_Requested_Business_Unit_Id !== null
            ? "" + x_Requested_Business_Unit_Id
            : "",
        Accept: "application/json"
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetProfiles(_response);
      });
  }

  protected processGetProfiles(
    response: AxiosResponse
  ): Promise<ProfileSummaryDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      if (Array.isArray(resultData200)) {
        result200 = [] as any;
        for (let item of resultData200)
          result200!.push(ProfileSummaryDto.fromJS(item));
      }
      return result200;
    } else if (status === 401) {
      const _responseText = response.data;
      return throwException("Unauthorized", status, _responseText, _headers);
    } else if (status === 403) {
      const _responseText = response.data;
      return throwException("Forbidden", status, _responseText, _headers);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<ProfileSummaryDto[]>(<any>null);
  }

  /**
   * Creates a new profile, scoped to the company/business unit of the current user.
   * @param x_Requested_Business_Unit_Id (optional)
   * @param body (optional)
   * @return Successfully created the profile.
   */
  createProfile(
    x_Requested_Business_Unit_Id?: any | undefined,
    body?: CreateProfileDto | undefined,
    cancelToken?: CancelToken | undefined
  ): Promise<string> {
    let url_ = this.baseUrl + "/api/v1/profiles";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_ = <AxiosRequestConfig>{
      data: content_,
      method: "POST",
      url: url_,
      headers: {
        "X-Requested-Business-Unit-Id":
          x_Requested_Business_Unit_Id !== undefined &&
          x_Requested_Business_Unit_Id !== null
            ? "" + x_Requested_Business_Unit_Id
            : "",
        "Content-Type": "application/json",
        Accept: "application/json"
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processCreateProfile(_response);
      });
  }

  protected processCreateProfile(response: AxiosResponse): Promise<string> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 201) {
      const _responseText = response.data;
      let result201: any = null;
      let resultData201 = _responseText;
      result201 = resultData201 !== undefined ? resultData201 : <any>null;
      return result201;
    } else if (status === 409) {
      const _responseText = response.data;
      let result409: any = null;
      let resultData409 = _responseText;
      result409 = ProblemDetails.fromJS(resultData409);
      return throwException(
        "Profile already exists.",
        status,
        _responseText,
        _headers,
        result409
      );
    } else if (status === 404) {
      const _responseText = response.data;
      let result404: any = null;
      let resultData404 = _responseText;
      result404 = ProblemDetails.fromJS(resultData404);
      return throwException(
        "Region not found.",
        status,
        _responseText,
        _headers,
        result404
      );
    } else if (status === 401) {
      const _responseText = response.data;
      return throwException("Unauthorized", status, _responseText, _headers);
    } else if (status === 403) {
      const _responseText = response.data;
      return throwException("Forbidden", status, _responseText, _headers);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<string>(<any>null);
  }

  /**
   * Updates a profile, scoped to the company/business unit of the current user.
   * @param x_Requested_Business_Unit_Id (optional)
   * @param body (optional)
   * @return Successfully updated the profile.
   */
  updateProfile(
    x_Requested_Business_Unit_Id?: any | undefined,
    body?: UpdateProfileDto | undefined,
    cancelToken?: CancelToken | undefined
  ): Promise<void> {
    let url_ = this.baseUrl + "/api/v1/profiles";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_ = <AxiosRequestConfig>{
      data: content_,
      method: "PUT",
      url: url_,
      headers: {
        "X-Requested-Business-Unit-Id":
          x_Requested_Business_Unit_Id !== undefined &&
          x_Requested_Business_Unit_Id !== null
            ? "" + x_Requested_Business_Unit_Id
            : "",
        "Content-Type": "application/json"
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processUpdateProfile(_response);
      });
  }

  protected processUpdateProfile(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 204) {
      const _responseText = response.data;
      return Promise.resolve<void>(<any>null);
    } else if (status === 404) {
      const _responseText = response.data;
      let result404: any = null;
      let resultData404 = _responseText;
      result404 = ProblemDetails.fromJS(resultData404);
      return throwException(
        "Profile/Region not found.",
        status,
        _responseText,
        _headers,
        result404
      );
    } else if (status === 401) {
      const _responseText = response.data;
      return throwException("Unauthorized", status, _responseText, _headers);
    } else if (status === 403) {
      const _responseText = response.data;
      return throwException("Forbidden", status, _responseText, _headers);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<void>(<any>null);
  }

  /**
   * Returns all regions, scoped to the company/business unit of the current user.
   * @param x_Requested_Business_Unit_Id (optional)
   * @return Success
   */
  getRegions(
    x_Requested_Business_Unit_Id?: any | undefined,
    cancelToken?: CancelToken | undefined
  ): Promise<RegionDto[]> {
    let url_ = this.baseUrl + "/api/v1/regions";
    url_ = url_.replace(/[?&]$/, "");

    let options_ = <AxiosRequestConfig>{
      method: "GET",
      url: url_,
      headers: {
        "X-Requested-Business-Unit-Id":
          x_Requested_Business_Unit_Id !== undefined &&
          x_Requested_Business_Unit_Id !== null
            ? "" + x_Requested_Business_Unit_Id
            : "",
        Accept: "application/json"
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetRegions(_response);
      });
  }

  protected processGetRegions(response: AxiosResponse): Promise<RegionDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      if (Array.isArray(resultData200)) {
        result200 = [] as any;
        for (let item of resultData200) result200!.push(RegionDto.fromJS(item));
      }
      return result200;
    } else if (status === 401) {
      const _responseText = response.data;
      return throwException("Unauthorized", status, _responseText, _headers);
    } else if (status === 403) {
      const _responseText = response.data;
      return throwException("Forbidden", status, _responseText, _headers);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<RegionDto[]>(<any>null);
  }

  /**
   * Creates a new region, scoped to the company/business unit of the current user.
   * @param x_Requested_Business_Unit_Id (optional)
   * @param body (optional)
   * @return Region created.
   */
  createRegion(
    x_Requested_Business_Unit_Id?: any | undefined,
    body?: CreateRegionDto | undefined,
    cancelToken?: CancelToken | undefined
  ): Promise<string> {
    let url_ = this.baseUrl + "/api/v1/regions";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_ = <AxiosRequestConfig>{
      data: content_,
      method: "POST",
      url: url_,
      headers: {
        "X-Requested-Business-Unit-Id":
          x_Requested_Business_Unit_Id !== undefined &&
          x_Requested_Business_Unit_Id !== null
            ? "" + x_Requested_Business_Unit_Id
            : "",
        "Content-Type": "application/json",
        Accept: "application/json"
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processCreateRegion(_response);
      });
  }

  protected processCreateRegion(response: AxiosResponse): Promise<string> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 201) {
      const _responseText = response.data;
      let result201: any = null;
      let resultData201 = _responseText;
      result201 = resultData201 !== undefined ? resultData201 : <any>null;
      return result201;
    } else if (status === 409) {
      const _responseText = response.data;
      let result409: any = null;
      let resultData409 = _responseText;
      result409 = ProblemDetails.fromJS(resultData409);
      return throwException(
        "Region code already in use.",
        status,
        _responseText,
        _headers,
        result409
      );
    } else if (status === 401) {
      const _responseText = response.data;
      return throwException("Unauthorized", status, _responseText, _headers);
    } else if (status === 403) {
      const _responseText = response.data;
      return throwException("Forbidden", status, _responseText, _headers);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<string>(<any>null);
  }

  /**
     * Returns the vendor specified by the unique code,
    scoped to the company/business unit of the current user.
     * @param x_Requested_Business_Unit_Id (optional) 
     * @return Success
     * @deprecated
     */
  getVendorByCode(
    code: string | null,
    x_Requested_Business_Unit_Id?: any | undefined,
    cancelToken?: CancelToken | undefined
  ): Promise<VendorDtoV1Response> {
    let url_ = this.baseUrl + "/api/v1/vendors/{code}";
    if (code === undefined || code === null)
      throw new Error("The parameter 'code' must be defined.");
    url_ = url_.replace("{code}", encodeURIComponent("" + code));
    url_ = url_.replace(/[?&]$/, "");

    let options_ = <AxiosRequestConfig>{
      method: "GET",
      url: url_,
      headers: {
        "X-Requested-Business-Unit-Id":
          x_Requested_Business_Unit_Id !== undefined &&
          x_Requested_Business_Unit_Id !== null
            ? "" + x_Requested_Business_Unit_Id
            : "",
        Accept: "application/json"
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetVendorByCode(_response);
      });
  }

  protected processGetVendorByCode(
    response: AxiosResponse
  ): Promise<VendorDtoV1Response> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = VendorDtoV1Response.fromJS(resultData200);
      return result200;
    } else if (status === 404) {
      const _responseText = response.data;
      return throwException(
        "Vendor not found",
        status,
        _responseText,
        _headers
      );
    } else if (status === 401) {
      const _responseText = response.data;
      return throwException("Unauthorized", status, _responseText, _headers);
    } else if (status === 403) {
      const _responseText = response.data;
      return throwException("Forbidden", status, _responseText, _headers);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<VendorDtoV1Response>(<any>null);
  }

  /**
   * Returns all vendors, scoped to the company/business unit of the current user.
   * @param x_Requested_Business_Unit_Id (optional)
   * @return Success
   * @deprecated
   */
  getVendors(
    x_Requested_Business_Unit_Id?: any | undefined,
    cancelToken?: CancelToken | undefined
  ): Promise<VendorSummaryDtoResponse[]> {
    let url_ = this.baseUrl + "/api/v1/vendors";
    url_ = url_.replace(/[?&]$/, "");

    let options_ = <AxiosRequestConfig>{
      method: "GET",
      url: url_,
      headers: {
        "X-Requested-Business-Unit-Id":
          x_Requested_Business_Unit_Id !== undefined &&
          x_Requested_Business_Unit_Id !== null
            ? "" + x_Requested_Business_Unit_Id
            : "",
        Accept: "application/json"
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetVendors(_response);
      });
  }

  protected processGetVendors(
    response: AxiosResponse
  ): Promise<VendorSummaryDtoResponse[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      if (Array.isArray(resultData200)) {
        result200 = [] as any;
        for (let item of resultData200)
          result200!.push(VendorSummaryDtoResponse.fromJS(item));
      }
      return result200;
    } else if (status === 401) {
      const _responseText = response.data;
      return throwException("Unauthorized", status, _responseText, _headers);
    } else if (status === 403) {
      const _responseText = response.data;
      return throwException("Forbidden", status, _responseText, _headers);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<VendorSummaryDtoResponse[]>(<any>null);
  }

  /**
   * Creates a new vendor, scoped to the company/business unit of the current user.
   * @param x_Requested_Business_Unit_Id (optional)
   * @param body (optional)
   * @return Successfully created the vendor.
   * @deprecated
   */
  createVendor(
    x_Requested_Business_Unit_Id?: any | undefined,
    body?: CreateVendorDto | undefined,
    cancelToken?: CancelToken | undefined
  ): Promise<string> {
    let url_ = this.baseUrl + "/api/v1/vendors";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_ = <AxiosRequestConfig>{
      data: content_,
      method: "POST",
      url: url_,
      headers: {
        "X-Requested-Business-Unit-Id":
          x_Requested_Business_Unit_Id !== undefined &&
          x_Requested_Business_Unit_Id !== null
            ? "" + x_Requested_Business_Unit_Id
            : "",
        "Content-Type": "application/json",
        Accept: "application/json"
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processCreateVendor(_response);
      });
  }

  protected processCreateVendor(response: AxiosResponse): Promise<string> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 201) {
      const _responseText = response.data;
      let result201: any = null;
      let resultData201 = _responseText;
      result201 = resultData201 !== undefined ? resultData201 : <any>null;
      return result201;
    } else if (status === 404) {
      const _responseText = response.data;
      let result404: any = null;
      let resultData404 = _responseText;
      result404 = ProblemDetails.fromJS(resultData404);
      return throwException(
        "Region/Company type not found.",
        status,
        _responseText,
        _headers,
        result404
      );
    } else if (status === 409) {
      const _responseText = response.data;
      let result409: any = null;
      let resultData409 = _responseText;
      result409 = ProblemDetails.fromJS(resultData409);
      return throwException(
        "Vendor code already exists.",
        status,
        _responseText,
        _headers,
        result409
      );
    } else if (status === 401) {
      const _responseText = response.data;
      return throwException("Unauthorized", status, _responseText, _headers);
    } else if (status === 403) {
      const _responseText = response.data;
      return throwException("Forbidden", status, _responseText, _headers);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<string>(<any>null);
  }

  /**
   * Returns all vendors with details, scoped to the company/business unit of the current user.
   * @param x_Requested_Business_Unit_Id (optional)
   * @return Success
   * @deprecated
   */
  getDetailedVendors(
    x_Requested_Business_Unit_Id?: any | undefined,
    cancelToken?: CancelToken | undefined
  ): Promise<VendorDtoV1Response[]> {
    let url_ = this.baseUrl + "/api/v1/vendors/detailed";
    url_ = url_.replace(/[?&]$/, "");

    let options_ = <AxiosRequestConfig>{
      method: "GET",
      url: url_,
      headers: {
        "X-Requested-Business-Unit-Id":
          x_Requested_Business_Unit_Id !== undefined &&
          x_Requested_Business_Unit_Id !== null
            ? "" + x_Requested_Business_Unit_Id
            : "",
        Accept: "application/json"
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetDetailedVendors(_response);
      });
  }

  protected processGetDetailedVendors(
    response: AxiosResponse
  ): Promise<VendorDtoV1Response[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      if (Array.isArray(resultData200)) {
        result200 = [] as any;
        for (let item of resultData200)
          result200!.push(VendorDtoV1Response.fromJS(item));
      }
      return result200;
    } else if (status === 401) {
      const _responseText = response.data;
      return throwException("Unauthorized", status, _responseText, _headers);
    } else if (status === 403) {
      const _responseText = response.data;
      return throwException("Forbidden", status, _responseText, _headers);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<VendorDtoV1Response[]>(<any>null);
  }

  /**
   * @param x_Requested_Business_Unit_Id (optional)
   * @param body (optional)
   * @return Success
   */
  upload(
    x_Requested_Business_Unit_Id?: any | undefined,
    body?: BulkImport | undefined,
    cancelToken?: CancelToken | undefined
  ): Promise<void> {
    let url_ = this.baseUrl + "/api/v1/bulk";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_ = <AxiosRequestConfig>{
      data: content_,
      method: "POST",
      url: url_,
      headers: {
        "X-Requested-Business-Unit-Id":
          x_Requested_Business_Unit_Id !== undefined &&
          x_Requested_Business_Unit_Id !== null
            ? "" + x_Requested_Business_Unit_Id
            : "",
        "Content-Type": "application/json"
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processUpload(_response);
      });
  }

  protected processUpload(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 204) {
      const _responseText = response.data;
      return Promise.resolve<void>(<any>null);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = ProblemDetails.fromJS(resultData400);
      return throwException(
        "Bad Request",
        status,
        _responseText,
        _headers,
        result400
      );
    } else if (status === 401) {
      const _responseText = response.data;
      return throwException("Unauthorized", status, _responseText, _headers);
    } else if (status === 403) {
      const _responseText = response.data;
      return throwException("Forbidden", status, _responseText, _headers);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<void>(<any>null);
  }

  /**
     * Adds a company logo to a storage and updates profile with logo url. 
    This method will overwrite any existing logos.
     * @param x_Requested_Business_Unit_Id (optional) 
     * @param body (optional) 
     * @param logo (optional) 
     * @return Successfully added the logo.
     */
  addProfileLogo(
    x_Requested_Business_Unit_Id?: any | undefined,
    body?: Body | undefined,
    logo?: FileParameter | null | undefined,
    cancelToken?: CancelToken | undefined
  ): Promise<string> {
    let url_ = this.baseUrl + "/api/v1/profiles/logo";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = new FormData();
    if (logo !== null && logo !== undefined)
      content_.append(
        "logo",
        logo.data,
        logo.fileName ? logo.fileName : "logo"
      );

    let options_ = <AxiosRequestConfig>{
      data: content_,
      method: "POST",
      url: url_,
      headers: {
        "X-Requested-Business-Unit-Id":
          x_Requested_Business_Unit_Id !== undefined &&
          x_Requested_Business_Unit_Id !== null
            ? "" + x_Requested_Business_Unit_Id
            : "",
        "Content-Type": "multipart/form-data",
        Accept: "application/json"
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processAddProfileLogo(_response);
      });
  }

  protected processAddProfileLogo(response: AxiosResponse): Promise<string> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = resultData200 !== undefined ? resultData200 : <any>null;
      return result200;
    } else if (status === 404) {
      const _responseText = response.data;
      let result404: any = null;
      let resultData404 = _responseText;
      result404 = ProblemDetails.fromJS(resultData404);
      return throwException(
        "Profile not found.",
        status,
        _responseText,
        _headers,
        result404
      );
    } else if (status === 413) {
      const _responseText = response.data;
      let result413: any = null;
      let resultData413 = _responseText;
      result413 = ProblemDetails.fromJS(resultData413);
      return throwException(
        "Invalid content length.",
        status,
        _responseText,
        _headers,
        result413
      );
    } else if (status === 415) {
      const _responseText = response.data;
      let result415: any = null;
      let resultData415 = _responseText;
      result415 = ProblemDetails.fromJS(resultData415);
      return throwException(
        "Invalid content type.",
        status,
        _responseText,
        _headers,
        result415
      );
    } else if (status === 401) {
      const _responseText = response.data;
      return throwException("Unauthorized", status, _responseText, _headers);
    } else if (status === 403) {
      const _responseText = response.data;
      return throwException("Forbidden", status, _responseText, _headers);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<string>(<any>null);
  }

  /**
   * Adds a contact, scoped to the company/business unit of the current user.
   * @param x_Requested_Business_Unit_Id (optional)
   * @param body (optional)
   * @return Successfully created contact.
   */
  createProfileContact(
    x_Requested_Business_Unit_Id?: any | undefined,
    body?: CreateProfileContactDto | undefined,
    cancelToken?: CancelToken | undefined
  ): Promise<string> {
    let url_ = this.baseUrl + "/api/v1/profiles/contacts";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_ = <AxiosRequestConfig>{
      data: content_,
      method: "POST",
      url: url_,
      headers: {
        "X-Requested-Business-Unit-Id":
          x_Requested_Business_Unit_Id !== undefined &&
          x_Requested_Business_Unit_Id !== null
            ? "" + x_Requested_Business_Unit_Id
            : "",
        "Content-Type": "application/json",
        Accept: "application/json"
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processCreateProfileContact(_response);
      });
  }

  protected processCreateProfileContact(
    response: AxiosResponse
  ): Promise<string> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 201) {
      const _responseText = response.data;
      let result201: any = null;
      let resultData201 = _responseText;
      result201 = resultData201 !== undefined ? resultData201 : <any>null;
      return result201;
    } else if (status === 404) {
      const _responseText = response.data;
      let result404: any = null;
      let resultData404 = _responseText;
      result404 = ProblemDetails.fromJS(resultData404);
      return throwException(
        "Profile not found.",
        status,
        _responseText,
        _headers,
        result404
      );
    } else if (status === 401) {
      const _responseText = response.data;
      return throwException("Unauthorized", status, _responseText, _headers);
    } else if (status === 403) {
      const _responseText = response.data;
      return throwException("Forbidden", status, _responseText, _headers);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<string>(<any>null);
  }

  /**
   * Creates a minority status, scoped to the company/business unit of the current user.
   * @param x_Requested_Business_Unit_Id (optional)
   * @param body (optional)
   * @return Successfully created minority status.
   */
  createProfileMinorityStatus(
    x_Requested_Business_Unit_Id?: any | undefined,
    body?: CreateProfileMinorityStatusDto | undefined,
    cancelToken?: CancelToken | undefined
  ): Promise<string> {
    let url_ = this.baseUrl + "/api/v1/profiles/statuses";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_ = <AxiosRequestConfig>{
      data: content_,
      method: "POST",
      url: url_,
      headers: {
        "X-Requested-Business-Unit-Id":
          x_Requested_Business_Unit_Id !== undefined &&
          x_Requested_Business_Unit_Id !== null
            ? "" + x_Requested_Business_Unit_Id
            : "",
        "Content-Type": "application/json",
        Accept: "application/json"
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processCreateProfileMinorityStatus(_response);
      });
  }

  protected processCreateProfileMinorityStatus(
    response: AxiosResponse
  ): Promise<string> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 201) {
      const _responseText = response.data;
      let result201: any = null;
      let resultData201 = _responseText;
      result201 = resultData201 !== undefined ? resultData201 : <any>null;
      return result201;
    } else if (status === 404) {
      const _responseText = response.data;
      let result404: any = null;
      let resultData404 = _responseText;
      result404 = ProblemDetails.fromJS(resultData404);
      return throwException(
        "Profile/Minority Type not found.",
        status,
        _responseText,
        _headers,
        result404
      );
    } else if (status === 401) {
      const _responseText = response.data;
      return throwException("Unauthorized", status, _responseText, _headers);
    } else if (status === 403) {
      const _responseText = response.data;
      return throwException("Forbidden", status, _responseText, _headers);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<string>(<any>null);
  }

  /**
   * Adds a product, scoped to the company/business unit of the current user.
   * @param x_Requested_Business_Unit_Id (optional)
   * @param body (optional)
   * @return Successfully created product.
   */
  createProfileProduct(
    x_Requested_Business_Unit_Id?: any | undefined,
    body?: CreateProfileProductDto | undefined,
    cancelToken?: CancelToken | undefined
  ): Promise<string> {
    let url_ = this.baseUrl + "/api/v1/profiles/products";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_ = <AxiosRequestConfig>{
      data: content_,
      method: "POST",
      url: url_,
      headers: {
        "X-Requested-Business-Unit-Id":
          x_Requested_Business_Unit_Id !== undefined &&
          x_Requested_Business_Unit_Id !== null
            ? "" + x_Requested_Business_Unit_Id
            : "",
        "Content-Type": "application/json",
        Accept: "application/json"
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processCreateProfileProduct(_response);
      });
  }

  protected processCreateProfileProduct(
    response: AxiosResponse
  ): Promise<string> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 201) {
      const _responseText = response.data;
      let result201: any = null;
      let resultData201 = _responseText;
      result201 = resultData201 !== undefined ? resultData201 : <any>null;
      return result201;
    } else if (status === 404) {
      const _responseText = response.data;
      let result404: any = null;
      let resultData404 = _responseText;
      result404 = ProblemDetails.fromJS(resultData404);
      return throwException(
        "Profile/Product not found.",
        status,
        _responseText,
        _headers,
        result404
      );
    } else if (status === 401) {
      const _responseText = response.data;
      return throwException("Unauthorized", status, _responseText, _headers);
    } else if (status === 403) {
      const _responseText = response.data;
      return throwException("Forbidden", status, _responseText, _headers);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<string>(<any>null);
  }

  /**
   * Adds a contact, scoped to the company/business unit of the current user.
   * @param x_Requested_Business_Unit_Id (optional)
   * @param body (optional)
   * @return Successfully created contact.
   */
  createVendorContact(
    vendorId: string,
    x_Requested_Business_Unit_Id?: any | undefined,
    body?: CreateVendorContactDto | undefined,
    cancelToken?: CancelToken | undefined
  ): Promise<string> {
    let url_ = this.baseUrl + "/api/v1/vendors/{vendorId}/contacts";
    if (vendorId === undefined || vendorId === null)
      throw new Error("The parameter 'vendorId' must be defined.");
    url_ = url_.replace("{vendorId}", encodeURIComponent("" + vendorId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_ = <AxiosRequestConfig>{
      data: content_,
      method: "POST",
      url: url_,
      headers: {
        "X-Requested-Business-Unit-Id":
          x_Requested_Business_Unit_Id !== undefined &&
          x_Requested_Business_Unit_Id !== null
            ? "" + x_Requested_Business_Unit_Id
            : "",
        "Content-Type": "application/json",
        Accept: "application/json"
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processCreateVendorContact(_response);
      });
  }

  protected processCreateVendorContact(
    response: AxiosResponse
  ): Promise<string> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 201) {
      const _responseText = response.data;
      let result201: any = null;
      let resultData201 = _responseText;
      result201 = resultData201 !== undefined ? resultData201 : <any>null;
      return result201;
    } else if (status === 404) {
      const _responseText = response.data;
      let result404: any = null;
      let resultData404 = _responseText;
      result404 = ProblemDetails.fromJS(resultData404);
      return throwException(
        "Vendor not found.",
        status,
        _responseText,
        _headers,
        result404
      );
    } else if (status === 401) {
      const _responseText = response.data;
      return throwException("Unauthorized", status, _responseText, _headers);
    } else if (status === 403) {
      const _responseText = response.data;
      return throwException("Forbidden", status, _responseText, _headers);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<string>(<any>null);
  }

  /**
   * Creates a minority status, scoped to the company/business unit of the current user.
   * @param x_Requested_Business_Unit_Id (optional)
   * @param body (optional)
   * @return Successfully created minority status.
   */
  createVendorMinorityStatus(
    vendorId: string,
    x_Requested_Business_Unit_Id?: any | undefined,
    body?: CreateVendorMinorityStatusDto | undefined,
    cancelToken?: CancelToken | undefined
  ): Promise<string> {
    let url_ = this.baseUrl + "/api/v1/vendors/{vendorId}/statuses";
    if (vendorId === undefined || vendorId === null)
      throw new Error("The parameter 'vendorId' must be defined.");
    url_ = url_.replace("{vendorId}", encodeURIComponent("" + vendorId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_ = <AxiosRequestConfig>{
      data: content_,
      method: "POST",
      url: url_,
      headers: {
        "X-Requested-Business-Unit-Id":
          x_Requested_Business_Unit_Id !== undefined &&
          x_Requested_Business_Unit_Id !== null
            ? "" + x_Requested_Business_Unit_Id
            : "",
        "Content-Type": "application/json",
        Accept: "application/json"
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processCreateVendorMinorityStatus(_response);
      });
  }

  protected processCreateVendorMinorityStatus(
    response: AxiosResponse
  ): Promise<string> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 201) {
      const _responseText = response.data;
      let result201: any = null;
      let resultData201 = _responseText;
      result201 = resultData201 !== undefined ? resultData201 : <any>null;
      return result201;
    } else if (status === 404) {
      const _responseText = response.data;
      let result404: any = null;
      let resultData404 = _responseText;
      result404 = ProblemDetails.fromJS(resultData404);
      return throwException(
        "Vendor/Minority status not found.",
        status,
        _responseText,
        _headers,
        result404
      );
    } else if (status === 401) {
      const _responseText = response.data;
      return throwException("Unauthorized", status, _responseText, _headers);
    } else if (status === 403) {
      const _responseText = response.data;
      return throwException("Forbidden", status, _responseText, _headers);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<string>(<any>null);
  }

  /**
   * Adds a product, scoped to the company/business unit of the current user.
   * @param x_Requested_Business_Unit_Id (optional)
   * @param body (optional)
   * @return Successfully created product.
   */
  createVendorProduct(
    vendorId: string,
    x_Requested_Business_Unit_Id?: any | undefined,
    body?: CreateVendorProductDto | undefined,
    cancelToken?: CancelToken | undefined
  ): Promise<string> {
    let url_ = this.baseUrl + "/api/v1/vendors/{vendorId}/products";
    if (vendorId === undefined || vendorId === null)
      throw new Error("The parameter 'vendorId' must be defined.");
    url_ = url_.replace("{vendorId}", encodeURIComponent("" + vendorId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_ = <AxiosRequestConfig>{
      data: content_,
      method: "POST",
      url: url_,
      headers: {
        "X-Requested-Business-Unit-Id":
          x_Requested_Business_Unit_Id !== undefined &&
          x_Requested_Business_Unit_Id !== null
            ? "" + x_Requested_Business_Unit_Id
            : "",
        "Content-Type": "application/json",
        Accept: "application/json"
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processCreateVendorProduct(_response);
      });
  }

  protected processCreateVendorProduct(
    response: AxiosResponse
  ): Promise<string> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 201) {
      const _responseText = response.data;
      let result201: any = null;
      let resultData201 = _responseText;
      result201 = resultData201 !== undefined ? resultData201 : <any>null;
      return result201;
    } else if (status === 404) {
      const _responseText = response.data;
      let result404: any = null;
      let resultData404 = _responseText;
      result404 = ProblemDetails.fromJS(resultData404);
      return throwException(
        "Vendor/Product not found.",
        status,
        _responseText,
        _headers,
        result404
      );
    } else if (status === 401) {
      const _responseText = response.data;
      return throwException("Unauthorized", status, _responseText, _headers);
    } else if (status === 403) {
      const _responseText = response.data;
      return throwException("Forbidden", status, _responseText, _headers);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<string>(<any>null);
  }
}

export class ProblemDetails implements IProblemDetails {
  type?: string | undefined;
  title?: string | undefined;
  status?: number | undefined;
  detail?: string | undefined;
  instance?: string | undefined;
  readonly extensions?: { [key: string]: any } | undefined;

  constructor(data?: IProblemDetails) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.type = _data["type"];
      this.title = _data["title"];
      this.status = _data["status"];
      this.detail = _data["detail"];
      this.instance = _data["instance"];
      if (_data["extensions"]) {
        (<any>this).extensions = {} as any;
        for (let key in _data["extensions"]) {
          if (_data["extensions"].hasOwnProperty(key))
            (<any>this).extensions![key] = _data["extensions"][key];
        }
      }
    }
  }

  static fromJS(data: any): ProblemDetails {
    data = typeof data === "object" ? data : {};
    let result = new ProblemDetails();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["type"] = this.type;
    data["title"] = this.title;
    data["status"] = this.status;
    data["detail"] = this.detail;
    data["instance"] = this.instance;
    if (this.extensions) {
      data["extensions"] = {};
      for (let key in this.extensions) {
        if (this.extensions.hasOwnProperty(key))
          data["extensions"][key] = this.extensions[key];
      }
    }
    return data;
  }
}

export interface IProblemDetails {
  type?: string | undefined;
  title?: string | undefined;
  status?: number | undefined;
  detail?: string | undefined;
  instance?: string | undefined;
  extensions?: { [key: string]: any } | undefined;
}

/** A company type data transfer object. */
export class CompanyTypeDto implements ICompanyTypeDto {
  /** The type's unique identifier. */
  id?: string;
  /** The type's unique code. */
  code?: string | undefined;
  /** The type's description. */
  description?: string | undefined;

  constructor(data?: ICompanyTypeDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.code = _data["code"];
      this.description = _data["description"];
    }
  }

  static fromJS(data: any): CompanyTypeDto {
    data = typeof data === "object" ? data : {};
    let result = new CompanyTypeDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.id;
    data["code"] = this.code;
    data["description"] = this.description;
    return data;
  }
}

/** A company type data transfer object. */
export interface ICompanyTypeDto {
  /** The type's unique identifier. */
  id?: string;
  /** The type's unique code. */
  code?: string | undefined;
  /** The type's description. */
  description?: string | undefined;
}

/** A data transfer object for requesting the update of a company type. */
export class UpdateCompanyTypeDto implements IUpdateCompanyTypeDto {
  /** The existing company type's identifier. */
  id!: string;
  /** A unique company type code. */
  code!: string;
  /** The company type's description. */
  description?: string | undefined;

  constructor(data?: IUpdateCompanyTypeDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.code = _data["code"];
      this.description = _data["description"];
    }
  }

  static fromJS(data: any): UpdateCompanyTypeDto {
    data = typeof data === "object" ? data : {};
    let result = new UpdateCompanyTypeDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.id;
    data["code"] = this.code;
    data["description"] = this.description;
    return data;
  }
}

/** A data transfer object for requesting the update of a company type. */
export interface IUpdateCompanyTypeDto {
  /** The existing company type's identifier. */
  id: string;
  /** A unique company type code. */
  code: string;
  /** The company type's description. */
  description?: string | undefined;
}

/** Minority type data transfer object. */
export class MinorityTypeDto implements IMinorityTypeDto {
  /** The Minority type's unique identifier. */
  id?: string;
  /** Minority type code. */
  code?: string | undefined;
  /** Minority type description. */
  description?: string | undefined;

  constructor(data?: IMinorityTypeDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.code = _data["code"];
      this.description = _data["description"];
    }
  }

  static fromJS(data: any): MinorityTypeDto {
    data = typeof data === "object" ? data : {};
    let result = new MinorityTypeDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.id;
    data["code"] = this.code;
    data["description"] = this.description;
    return data;
  }
}

/** Minority type data transfer object. */
export interface IMinorityTypeDto {
  /** The Minority type's unique identifier. */
  id?: string;
  /** Minority type code. */
  code?: string | undefined;
  /** Minority type description. */
  description?: string | undefined;
}

/** A data transfer object for requesting the update of a minority type. */
export class UpdateMinorityTypeDto implements IUpdateMinorityTypeDto {
  /** The existing minority type's identifier. */
  id!: string;
  /** A unique minority type code. */
  code!: string;
  /** The minority type's description. */
  description?: string | undefined;

  constructor(data?: IUpdateMinorityTypeDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.code = _data["code"];
      this.description = _data["description"];
    }
  }

  static fromJS(data: any): UpdateMinorityTypeDto {
    data = typeof data === "object" ? data : {};
    let result = new UpdateMinorityTypeDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.id;
    data["code"] = this.code;
    data["description"] = this.description;
    return data;
  }
}

/** A data transfer object for requesting the update of a minority type. */
export interface IUpdateMinorityTypeDto {
  /** The existing minority type's identifier. */
  id: string;
  /** A unique minority type code. */
  code: string;
  /** The minority type's description. */
  description?: string | undefined;
}

/** A Product Type data transfer object. */
export class ProductTypeDto implements IProductTypeDto {
  /** The Product type's unique identifier. */
  id?: string;
  /** Product type code. */
  code?: string | undefined;
  /** Product type description. */
  description?: string | undefined;

  constructor(data?: IProductTypeDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.code = _data["code"];
      this.description = _data["description"];
    }
  }

  static fromJS(data: any): ProductTypeDto {
    data = typeof data === "object" ? data : {};
    let result = new ProductTypeDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.id;
    data["code"] = this.code;
    data["description"] = this.description;
    return data;
  }
}

/** A Product Type data transfer object. */
export interface IProductTypeDto {
  /** The Product type's unique identifier. */
  id?: string;
  /** Product type code. */
  code?: string | undefined;
  /** Product type description. */
  description?: string | undefined;
}

/** A data transfer object for requesting the update of a product type. */
export class UpdateProductTypeDto implements IUpdateProductTypeDto {
  /** Existing product type's identifier. */
  id!: string;
  /** Unique product type code. */
  code!: string;
  /** The product type's description. */
  description?: string | undefined;

  constructor(data?: IUpdateProductTypeDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.code = _data["code"];
      this.description = _data["description"];
    }
  }

  static fromJS(data: any): UpdateProductTypeDto {
    data = typeof data === "object" ? data : {};
    let result = new UpdateProductTypeDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.id;
    data["code"] = this.code;
    data["description"] = this.description;
    return data;
  }
}

/** A data transfer object for requesting the update of a product type. */
export interface IUpdateProductTypeDto {
  /** Existing product type's identifier. */
  id: string;
  /** Unique product type code. */
  code: string;
  /** The product type's description. */
  description?: string | undefined;
}

export class Address implements IAddress {
  addressLine1?: string | undefined;
  addressLine2?: string | undefined;
  building?: string | undefined;
  city?: string | undefined;
  stateProvince?: string | undefined;
  countryRegion?: string | undefined;
  postalCode?: string | undefined;

  constructor(data?: IAddress) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.addressLine1 = _data["addressLine1"];
      this.addressLine2 = _data["addressLine2"];
      this.building = _data["building"];
      this.city = _data["city"];
      this.stateProvince = _data["stateProvince"];
      this.countryRegion = _data["countryRegion"];
      this.postalCode = _data["postalCode"];
    }
  }

  static fromJS(data: any): Address {
    data = typeof data === "object" ? data : {};
    let result = new Address();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["addressLine1"] = this.addressLine1;
    data["addressLine2"] = this.addressLine2;
    data["building"] = this.building;
    data["city"] = this.city;
    data["stateProvince"] = this.stateProvince;
    data["countryRegion"] = this.countryRegion;
    data["postalCode"] = this.postalCode;
    return data;
  }
}

export interface IAddress {
  addressLine1?: string | undefined;
  addressLine2?: string | undefined;
  building?: string | undefined;
  city?: string | undefined;
  stateProvince?: string | undefined;
  countryRegion?: string | undefined;
  postalCode?: string | undefined;
}

/** A Region data transfer object. */
export class RegionDto implements IRegionDto {
  /** The Region's unique identifier. */
  id?: string;
  /** Region code. */
  code?: string | undefined;
  /** Region description. */
  description?: string | undefined;

  constructor(data?: IRegionDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.code = _data["code"];
      this.description = _data["description"];
    }
  }

  static fromJS(data: any): RegionDto {
    data = typeof data === "object" ? data : {};
    let result = new RegionDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.id;
    data["code"] = this.code;
    data["description"] = this.description;
    return data;
  }
}

/** A Region data transfer object. */
export interface IRegionDto {
  /** The Region's unique identifier. */
  id?: string;
  /** Region code. */
  code?: string | undefined;
  /** Region description. */
  description?: string | undefined;
}

export enum CommunicationMethod {
  None = "None",
  Email = "Email",
  Fax = "Fax",
  Print = "Print"
}

export class MinorityStatusDto implements IMinorityStatusDto {
  id?: string;
  companyId?: string;
  type?: MinorityTypeDto;
  certificationNumber?: string | undefined;
  percent?: number;

  constructor(data?: IMinorityStatusDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.companyId = _data["companyId"];
      this.type = _data["type"]
        ? MinorityTypeDto.fromJS(_data["type"])
        : <any>undefined;
      this.certificationNumber = _data["certificationNumber"];
      this.percent = _data["percent"];
    }
  }

  static fromJS(data: any): MinorityStatusDto {
    data = typeof data === "object" ? data : {};
    let result = new MinorityStatusDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.id;
    data["companyId"] = this.companyId;
    data["type"] = this.type ? this.type.toJSON() : <any>undefined;
    data["certificationNumber"] = this.certificationNumber;
    data["percent"] = this.percent;
    return data;
  }
}

export interface IMinorityStatusDto {
  id?: string;
  companyId?: string;
  type?: MinorityTypeDto;
  certificationNumber?: string | undefined;
  percent?: number;
}

export class ProductDto implements IProductDto {
  id?: string;
  companyId?: string;
  product?: ProductTypeDto;
  region?: RegionDto;
  date?: Date | undefined;

  constructor(data?: IProductDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.companyId = _data["companyId"];
      this.product = _data["product"]
        ? ProductTypeDto.fromJS(_data["product"])
        : <any>undefined;
      this.region = _data["region"]
        ? RegionDto.fromJS(_data["region"])
        : <any>undefined;
      this.date = _data["date"]
        ? new Date(_data["date"].toString())
        : <any>undefined;
    }
  }

  static fromJS(data: any): ProductDto {
    data = typeof data === "object" ? data : {};
    let result = new ProductDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.id;
    data["companyId"] = this.companyId;
    data["product"] = this.product ? this.product.toJSON() : <any>undefined;
    data["region"] = this.region ? this.region.toJSON() : <any>undefined;
    data["date"] = this.date ? this.date.toISOString() : <any>undefined;
    return data;
  }
}

export interface IProductDto {
  id?: string;
  companyId?: string;
  product?: ProductTypeDto;
  region?: RegionDto;
  date?: Date | undefined;
}

export interface IContactProduct {
  productTypeId: string;
  vendorProductId: string;
  code: string;
}

export class ContactDto implements IContactDto {
  id?: string;
  companyId?: string;
  firstName?: string | undefined;
  lastName?: string | undefined;
  title?: string | undefined;
  phoneNumber?: string | undefined;
  faxNumber?: string | undefined;
  cellPhoneNumber?: string | undefined;
  emailAddress?: string | undefined;
  isMainContact?: boolean;
  note?: string | undefined;
  /** A string specifying a contact's role. */
  role?: string | undefined;
  /** A DateTime when this contact was last contacted. */
  lastContacted?: Date | undefined;
  vendorLocationId?: string | undefined;
  products?: IContactProduct[] | undefined;

  constructor(data?: IContactDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.companyId = _data["companyId"];
      this.firstName = _data["firstName"];
      this.lastName = _data["lastName"];
      this.title = _data["title"];
      this.phoneNumber = _data["phoneNumber"];
      this.faxNumber = _data["faxNumber"];
      this.cellPhoneNumber = _data["cellPhoneNumber"];
      this.emailAddress = _data["emailAddress"];
      this.isMainContact = _data["isMainContact"];
      this.note = _data["note"];
      this.role = _data["role"];
      this.lastContacted = _data["lastContacted"]
        ? new Date(_data["lastContacted"].toString())
        : <any>undefined;
      this.vendorLocationId = _data["vendorLocationId"];
      this.products = _data["products"];
    }
  }

  static fromJS(data: any): ContactDto {
    data = typeof data === "object" ? data : {};
    let result = new ContactDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.id;
    data["companyId"] = this.companyId;
    data["firstName"] = this.firstName;
    data["lastName"] = this.lastName;
    data["title"] = this.title;
    data["phoneNumber"] = this.phoneNumber;
    data["faxNumber"] = this.faxNumber;
    data["cellPhoneNumber"] = this.cellPhoneNumber;
    data["emailAddress"] = this.emailAddress;
    data["isMainContact"] = this.isMainContact;
    data["note"] = this.note;
    data["role"] = this.role;
    data["lastContacted"] = this.lastContacted
      ? this.lastContacted.toISOString()
      : <any>undefined;
    data["vendorLocationId"] = this.vendorLocationId;
    data["products"] = this.products;
    return data;
  }
}

export interface IContactDto {
  id?: string;
  companyId?: string;
  firstName?: string | undefined;
  lastName?: string | undefined;
  title?: string | undefined;
  phoneNumber?: string | undefined;
  faxNumber?: string | undefined;
  cellPhoneNumber?: string | undefined;
  emailAddress?: string | undefined;
  isMainContact?: boolean;
  note?: string | undefined;
  /** A string specifying a contact's role. */
  role?: string | undefined;
  /** A DateTime when this contact was last contacted. */
  lastContacted?: Date | undefined;
  vendorLocationId?: string;
  products?: IContactProduct[] | undefined;
}

export class ProfileDto implements IProfileDto {
  /** The Profile's unique identifier. */
  id?: string;
  name?: string | undefined;
  primaryAddress?: Address;
  alternateAddress?: Address;
  phoneNumber?: string | undefined;
  faxNumber?: string | undefined;
  webAddress?: string | undefined;
  region?: RegionDto;
  communicationMethod?: CommunicationMethod;
  /** The accent color for the company. */
  profileAccentColor?: string | undefined;
  /** The public logo url for the company. */
  profileLogoUrl?: string | undefined;
  minorityStatuses?: MinorityStatusDto[] | undefined;
  products?: ProductDto[] | undefined;
  contacts?: ContactDto[] | undefined;

  constructor(data?: IProfileDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.name = _data["name"];
      this.primaryAddress = _data["primaryAddress"]
        ? Address.fromJS(_data["primaryAddress"])
        : <any>undefined;
      this.alternateAddress = _data["alternateAddress"]
        ? Address.fromJS(_data["alternateAddress"])
        : <any>undefined;
      this.phoneNumber = _data["phoneNumber"];
      this.faxNumber = _data["faxNumber"];
      this.webAddress = _data["webAddress"];
      this.region = _data["region"]
        ? RegionDto.fromJS(_data["region"])
        : <any>undefined;
      this.communicationMethod = _data["communicationMethod"];
      this.profileAccentColor = _data["profileAccentColor"];
      this.profileLogoUrl = _data["profileLogoUrl"];
      if (Array.isArray(_data["minorityStatuses"])) {
        this.minorityStatuses = [] as any;
        for (let item of _data["minorityStatuses"])
          this.minorityStatuses!.push(MinorityStatusDto.fromJS(item));
      }
      if (Array.isArray(_data["products"])) {
        this.products = [] as any;
        for (let item of _data["products"])
          this.products!.push(ProductDto.fromJS(item));
      }
      if (Array.isArray(_data["contacts"])) {
        this.contacts = [] as any;
        for (let item of _data["contacts"])
          this.contacts!.push(ContactDto.fromJS(item));
      }
    }
  }

  static fromJS(data: any): ProfileDto {
    data = typeof data === "object" ? data : {};
    let result = new ProfileDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.id;
    data["name"] = this.name;
    data["primaryAddress"] = this.primaryAddress
      ? this.primaryAddress.toJSON()
      : <any>undefined;
    data["alternateAddress"] = this.alternateAddress
      ? this.alternateAddress.toJSON()
      : <any>undefined;
    data["phoneNumber"] = this.phoneNumber;
    data["faxNumber"] = this.faxNumber;
    data["webAddress"] = this.webAddress;
    data["region"] = this.region ? this.region.toJSON() : <any>undefined;
    data["communicationMethod"] = this.communicationMethod;
    data["profileAccentColor"] = this.profileAccentColor;
    data["profileLogoUrl"] = this.profileLogoUrl;
    if (Array.isArray(this.minorityStatuses)) {
      data["minorityStatuses"] = [];
      for (let item of this.minorityStatuses)
        data["minorityStatuses"].push(item.toJSON());
    }
    if (Array.isArray(this.products)) {
      data["products"] = [];
      for (let item of this.products) data["products"].push(item.toJSON());
    }
    if (Array.isArray(this.contacts)) {
      data["contacts"] = [];
      for (let item of this.contacts) data["contacts"].push(item.toJSON());
    }
    return data;
  }
}

export interface IProfileDto {
  /** The Profile's unique identifier. */
  id?: string;
  name?: string | undefined;
  primaryAddress?: Address;
  alternateAddress?: Address;
  phoneNumber?: string | undefined;
  faxNumber?: string | undefined;
  webAddress?: string | undefined;
  region?: RegionDto;
  communicationMethod?: CommunicationMethod;
  /** The accent color for the company. */
  profileAccentColor?: string | undefined;
  /** The public logo url for the company. */
  profileLogoUrl?: string | undefined;
  minorityStatuses?: MinorityStatusDto[] | undefined;
  products?: ProductDto[] | undefined;
  contacts?: ContactDto[] | undefined;
}

/** A data transfer object for requesting an update to a contact. */
export class UpdateProfileContactDto implements IUpdateProfileContactDto {
  /** The contact's unique identifier. */
  id!: string;
  /** The contact's first name. */
  firstName?: string | undefined;
  /** The contact's last name. */
  lastName?: string | undefined;
  /** The contact's title. */
  title?: string | undefined;
  /** The contact's phone number. */
  phoneNumber?: string | undefined;
  /** The contact's fax number. */
  faxNumber?: string | undefined;
  /** The contact's cell phone number. */
  cellPhoneNumber?: string | undefined;
  /** The contact's email address. */
  emailAddress?: string | undefined;
  /** The contact's note. */
  note?: string | undefined;
  /** A boolean indicating whether this contact is the company's main contact. */
  isMainContact?: boolean;

  constructor(data?: IUpdateProfileContactDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.firstName = _data["firstName"];
      this.lastName = _data["lastName"];
      this.title = _data["title"];
      this.phoneNumber = _data["phoneNumber"];
      this.faxNumber = _data["faxNumber"];
      this.cellPhoneNumber = _data["cellPhoneNumber"];
      this.emailAddress = _data["emailAddress"];
      this.note = _data["note"];
      this.isMainContact = _data["isMainContact"];
    }
  }

  static fromJS(data: any): UpdateProfileContactDto {
    data = typeof data === "object" ? data : {};
    let result = new UpdateProfileContactDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.id;
    data["firstName"] = this.firstName;
    data["lastName"] = this.lastName;
    data["title"] = this.title;
    data["phoneNumber"] = this.phoneNumber;
    data["faxNumber"] = this.faxNumber;
    data["cellPhoneNumber"] = this.cellPhoneNumber;
    data["emailAddress"] = this.emailAddress;
    data["note"] = this.note;
    data["isMainContact"] = this.isMainContact;
    return data;
  }
}

/** A data transfer object for requesting an update to a contact. */
export interface IUpdateProfileContactDto {
  /** The contact's unique identifier. */
  id: string;
  /** The contact's first name. */
  firstName?: string | undefined;
  /** The contact's last name. */
  lastName?: string | undefined;
  /** The contact's title. */
  title?: string | undefined;
  /** The contact's phone number. */
  phoneNumber?: string | undefined;
  /** The contact's fax number. */
  faxNumber?: string | undefined;
  /** The contact's cell phone number. */
  cellPhoneNumber?: string | undefined;
  /** The contact's email address. */
  emailAddress?: string | undefined;
  /** The contact's note. */
  note?: string | undefined;
  /** A boolean indicating whether this contact is the company's main contact. */
  isMainContact?: boolean;
}

/** A data transfer object for requesting an update of a profile's minority status. */
export class UpdateProfileMinorityStatusDto
  implements IUpdateProfileMinorityStatusDto {
  /** The profile minority status's unique identifier. */
  id!: string;
  /** The minority status's type unique identifier. */
  minorityTypeId!: string;
  /** The minority status certification number. */
  certificationNumber?: string | undefined;
  /** The minority percentage. */
  percent?: number;

  constructor(data?: IUpdateProfileMinorityStatusDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.minorityTypeId = _data["minorityTypeId"];
      this.certificationNumber = _data["certificationNumber"];
      this.percent = _data["percent"];
    }
  }

  static fromJS(data: any): UpdateProfileMinorityStatusDto {
    data = typeof data === "object" ? data : {};
    let result = new UpdateProfileMinorityStatusDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.id;
    data["minorityTypeId"] = this.minorityTypeId;
    data["certificationNumber"] = this.certificationNumber;
    data["percent"] = this.percent;
    return data;
  }
}

/** A data transfer object for requesting an update of a profile's minority status. */
export interface IUpdateProfileMinorityStatusDto {
  /** The profile minority status's unique identifier. */
  id: string;
  /** The minority status's type unique identifier. */
  minorityTypeId: string;
  /** The minority status certification number. */
  certificationNumber?: string | undefined;
  /** The minority percentage. */
  percent?: number;
}

/** An immutable command message for requesting the update of an company products. */
export class UpdateProfileProductDto implements IUpdateProfileProductDto {
  /** The company product's unique identifier. */
  id!: string;
  /** The product types's unique identifier. */
  productTypeId!: string;
  /** The product region's unique identifier. */
  regionId?: string | undefined;
  /** The date. */
  date?: Date | undefined;

  constructor(data?: IUpdateProfileProductDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.productTypeId = _data["productTypeId"];
      this.regionId = _data["regionId"];
      this.date = _data["date"]
        ? new Date(_data["date"].toString())
        : <any>undefined;
    }
  }

  static fromJS(data: any): UpdateProfileProductDto {
    data = typeof data === "object" ? data : {};
    let result = new UpdateProfileProductDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.id;
    data["productTypeId"] = this.productTypeId;
    data["regionId"] = this.regionId;
    data["date"] = this.date ? this.date.toISOString() : <any>undefined;
    return data;
  }
}

/** An immutable command message for requesting the update of an company products. */
export interface IUpdateProfileProductDto {
  /** The company product's unique identifier. */
  id: string;
  /** The product types's unique identifier. */
  productTypeId: string;
  /** The product region's unique identifier. */
  regionId?: string | undefined;
  /** The date. */
  date?: Date | undefined;
}

/** A data transfer object for requesting the update of a Region. */
export class UpdateRegionDto implements IUpdateRegionDto {
  /** The existing region's unique identifier. */
  id!: string;
  /** The the region's unique code. */
  code!: string;
  /** The region's description. */
  description?: string | undefined;

  constructor(data?: IUpdateRegionDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.code = _data["code"];
      this.description = _data["description"];
    }
  }

  static fromJS(data: any): UpdateRegionDto {
    data = typeof data === "object" ? data : {};
    let result = new UpdateRegionDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.id;
    data["code"] = this.code;
    data["description"] = this.description;
    return data;
  }
}

/** A data transfer object for requesting the update of a Region. */
export interface IUpdateRegionDto {
  /** The existing region's unique identifier. */
  id: string;
  /** The the region's unique code. */
  code: string;
  /** The region's description. */
  description?: string | undefined;
}

/** A vendor data transfer object. */
export class VendorDtoV1Response implements IVendorDtoV1Response {
  /** The company's unique identifier. */
  id!: string;
  /** The company's unique code. */
  code!: string;
  heavyBidCode!: string;
  /** The company's name. */
  name?: string | undefined;
  type?: CompanyTypeDto;
  region?: RegionDto;
  communicationMethod?: CommunicationMethod;
  /** A flag indicating if this company is bonded. */
  isBonded?: boolean;
  /** The rate at which this company is bonded. */
  bondRate?: number;
  /** Notes about this company. */
  note?: string | undefined;
  primaryAddress?: Address;
  alternateAddress?: Address;
  /** The vendor's phone number. */
  phoneNumber?: string | undefined;
  /** The vendor's fax number. */
  faxNumber?: string | undefined;
  /** The company's website address. */
  webAddress?: string | undefined;
  /** The list of statuses this company has. */
  minorityStatuses!: MinorityStatusDto[];
  /** The list of products this company offers. */
  products!: ProductDto[];
  /** The list of contacts at this company. */
  contacts!: ContactDto[];

  constructor(data?: IVendorDtoV1Response) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
    if (!data) {
      this.minorityStatuses = [];
      this.products = [];
      this.contacts = [];
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.code = _data["code"];
      this.heavyBidCode = _data["heavyBidCode"];
      this.name = _data["name"];
      this.type = _data["type"]
        ? CompanyTypeDto.fromJS(_data["type"])
        : <any>undefined;
      this.region = _data["region"]
        ? RegionDto.fromJS(_data["region"])
        : <any>undefined;
      this.communicationMethod = _data["communicationMethod"];
      this.isBonded = _data["isBonded"];
      this.bondRate = _data["bondRate"];
      this.note = _data["note"];
      this.primaryAddress = _data["primaryAddress"]
        ? Address.fromJS(_data["primaryAddress"])
        : <any>undefined;
      this.alternateAddress = _data["alternateAddress"]
        ? Address.fromJS(_data["alternateAddress"])
        : <any>undefined;
      this.phoneNumber = _data["phoneNumber"];
      this.faxNumber = _data["faxNumber"];
      this.webAddress = _data["webAddress"];
      if (Array.isArray(_data["minorityStatuses"])) {
        this.minorityStatuses = [] as any;
        for (let item of _data["minorityStatuses"])
          this.minorityStatuses!.push(MinorityStatusDto.fromJS(item));
      }
      if (Array.isArray(_data["products"])) {
        this.products = [] as any;
        for (let item of _data["products"])
          this.products!.push(ProductDto.fromJS(item));
      }
      if (Array.isArray(_data["contacts"])) {
        this.contacts = [] as any;
        for (let item of _data["contacts"])
          this.contacts!.push(ContactDto.fromJS(item));
      }
    }
  }

  static fromJS(data: any): VendorDtoV1Response {
    data = typeof data === "object" ? data : {};
    let result = new VendorDtoV1Response();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.id;
    data["code"] = this.code;
    data["heavyBidCode"] = this.heavyBidCode;
    data["name"] = this.name;
    data["type"] = this.type ? this.type.toJSON() : <any>undefined;
    data["region"] = this.region ? this.region.toJSON() : <any>undefined;
    data["communicationMethod"] = this.communicationMethod;
    data["isBonded"] = this.isBonded;
    data["bondRate"] = this.bondRate;
    data["note"] = this.note;
    data["primaryAddress"] = this.primaryAddress
      ? this.primaryAddress.toJSON()
      : <any>undefined;
    data["alternateAddress"] = this.alternateAddress
      ? this.alternateAddress.toJSON()
      : <any>undefined;
    data["phoneNumber"] = this.phoneNumber;
    data["faxNumber"] = this.faxNumber;
    data["webAddress"] = this.webAddress;
    if (Array.isArray(this.minorityStatuses)) {
      data["minorityStatuses"] = [];
      for (let item of this.minorityStatuses)
        data["minorityStatuses"].push(item.toJSON());
    }
    if (Array.isArray(this.products)) {
      data["products"] = [];
      for (let item of this.products) data["products"].push(item.toJSON());
    }
    if (Array.isArray(this.contacts)) {
      data["contacts"] = [];
      for (let item of this.contacts) data["contacts"].push(item.toJSON());
    }
    return data;
  }
}

/** A vendor data transfer object. */
export interface IVendorDtoV1Response {
  /** The company's unique identifier. */
  id: string;
  /** The company's unique code. */
  code: string;
  heavyBidCode: string;
  /** The company's name. */
  name?: string | undefined;
  type?: CompanyTypeDto;
  region?: RegionDto;
  communicationMethod?: CommunicationMethod;
  /** A flag indicating if this company is bonded. */
  isBonded?: boolean;
  /** The rate at which this company is bonded. */
  bondRate?: number;
  /** Notes about this company. */
  note?: string | undefined;
  primaryAddress?: Address;
  alternateAddress?: Address;
  /** The vendor's phone number. */
  phoneNumber?: string | undefined;
  /** The vendor's fax number. */
  faxNumber?: string | undefined;
  /** The company's website address. */
  webAddress?: string | undefined;
  /** The list of statuses this company has. */
  minorityStatuses: MinorityStatusDto[];
  /** The list of products this company offers. */
  products: ProductDto[];
  /** The list of contacts at this company. */
  contacts: ContactDto[];
  /** The list of vendor locations for this company. */
  locations?: IVendorLocationDto[];
  /** The vendor's accounting code. */
  accountingCode?: string;
}

/** A data transfer object for requesting the update of a vendor. */
export class UpdateVendorDto implements IUpdateVendorDto {
  /** The vendor's unique identifier. */
  id?: string;
  /** The vendor's unique code. */
  code!: string;
  /** The vendor's name. */
  name?: string | undefined;
  /** The vendor type unique identifier. */
  typeId?: string | undefined;
  primaryAddress?: Address;
  alternateAddress?: Address;
  /** The vendor's phone number. */
  phoneNumber?: string | undefined;
  /** The vendor's fax number. */
  faxNumber?: string | undefined;
  /** The vendor's website address. */
  webAddress?: string | undefined;
  /** The unique identifier of the region the vendor operates in. */
  regionId?: string | undefined;
  communicationMethod?: CommunicationMethod;
  /** A collection of vendor products */
  products?: ProductDto[] | undefined;
  /** A flag indicating if this vendor is bonded. */
  isBonded?: boolean;
  /** The rate at which this vendor is bonded. */
  bondRate?: number;
  /** Notes about this vendor. */
  note?: string | undefined;
  companyType?: CompanyTypeDto;

  constructor(data?: IUpdateVendorDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.code = _data["code"];
      this.name = _data["name"];
      this.typeId = _data["typeId"];
      this.primaryAddress = _data["primaryAddress"]
        ? Address.fromJS(_data["primaryAddress"])
        : <any>undefined;
      this.alternateAddress = _data["alternateAddress"]
        ? Address.fromJS(_data["alternateAddress"])
        : <any>undefined;
      this.phoneNumber = _data["phoneNumber"];
      this.faxNumber = _data["faxNumber"];
      this.webAddress = _data["webAddress"];
      this.regionId = _data["regionId"];
      this.communicationMethod = _data["communicationMethod"];
      if (Array.isArray(_data["products"])) {
        this.products = [] as any;
        for (let item of _data["products"])
          this.products!.push(ProductDto.fromJS(item));
      }
      this.isBonded = _data["isBonded"];
      this.bondRate = _data["bondRate"];
      this.note = _data["note"];
      this.products = _data["products"];
      this.companyType = _data["companyType"]
        ? CompanyTypeDto.fromJS(_data["companyType"])
        : <any>undefined;
    }
  }

  static fromJS(data: any): UpdateVendorDto {
    data = typeof data === "object" ? data : {};
    let result = new UpdateVendorDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.id;
    data["code"] = this.code;
    data["name"] = this.name;
    data["typeId"] = this.typeId;
    data["primaryAddress"] = this.primaryAddress
      ? this.primaryAddress.toJSON()
      : <any>undefined;
    data["alternateAddress"] = this.alternateAddress
      ? this.alternateAddress.toJSON()
      : <any>undefined;
    data["phoneNumber"] = this.phoneNumber;
    data["faxNumber"] = this.faxNumber;
    data["webAddress"] = this.webAddress;
    data["regionId"] = this.regionId;
    data["communicationMethod"] = this.communicationMethod;
    if (Array.isArray(this.products)) {
      data["products"] = [];
      for (let item of this.products) data["products"].push(item.toJSON());
    }
    data["isBonded"] = this.isBonded;
    data["bondRate"] = this.bondRate;
    data["note"] = this.note;
    data["products"] = this.products;
    data["companyType"] = this.companyType
      ? this.companyType.toJSON()
      : <any>undefined;
    return data;
  }
}

/** A data transfer object for requesting the update of a vendor. */
export interface IUpdateVendorDto {
  /** The vendor's unique identifier. */
  id?: string;
  /** The vendor's unique code. */
  code: string;
  /** The vendor's name. */
  name?: string | undefined;
  /** The vendor type unique identifier. */
  typeId?: string | undefined;
  primaryAddress?: Address;
  alternateAddress?: Address;
  /** The vendor's phone number. */
  phoneNumber?: string | undefined;
  /** The vendor's fax number. */
  faxNumber?: string | undefined;
  /** The vendor's website address. */
  webAddress?: string | undefined;
  /** The unique identifier of the region the vendor operates in. */
  regionId?: string | undefined;
  communicationMethod?: CommunicationMethod;
  /** A collection of vendor products */
  products?: ProductDto[] | undefined;
  /** A flag indicating if this vendor is bonded. */
  isBonded?: boolean;
  /** The rate at which this vendor is bonded. */
  bondRate?: number;
  /** Notes about this vendor. */
  note?: string | undefined;
}

/** A data transfer object for requesting an update to a contact. */
export class UpdateVendorContactDto implements IUpdateVendorContactDto {
  /** The vendor's unique identifier. */
  vendorId!: string;
  /** The contact's unique identifier. */
  contactId!: string;
  /** The contact's first name. */
  firstName?: string | undefined;
  /** The contact's last name. */
  lastName?: string | undefined;
  /** The contact's title. */
  title?: string | undefined;
  /** The contact's phone number. */
  phoneNumber?: string | undefined;
  /** The contact's fax number. */
  faxNumber?: string | undefined;
  /** The contact's cell phone number. */
  cellPhoneNumber?: string | undefined;
  /** The contact's email address. */
  emailAddress?: string | undefined;
  /** The contact's note. */
  note?: string | undefined;
  /** A boolean indicating whether this contact is the company's main contact. */
  isMainContact?: boolean;
  /** A string specifying a contact's role. */
  role?: string | undefined;
  /** A DateTime when this contact was last contacted. */
  lastContacted?: Date | undefined;

  constructor(data?: IUpdateVendorContactDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.vendorId = _data["vendorId"];
      this.contactId = _data["contactId"];
      this.firstName = _data["firstName"];
      this.lastName = _data["lastName"];
      this.title = _data["title"];
      this.phoneNumber = _data["phoneNumber"];
      this.faxNumber = _data["faxNumber"];
      this.cellPhoneNumber = _data["cellPhoneNumber"];
      this.emailAddress = _data["emailAddress"];
      this.note = _data["note"];
      this.isMainContact = _data["isMainContact"];
      this.role = _data["role"];
      this.lastContacted = _data["lastContacted"]
        ? new Date(_data["lastContacted"].toString())
        : <any>undefined;
    }
  }

  static fromJS(data: any): UpdateVendorContactDto {
    data = typeof data === "object" ? data : {};
    let result = new UpdateVendorContactDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["vendorId"] = this.vendorId;
    data["contactId"] = this.contactId;
    data["firstName"] = this.firstName;
    data["lastName"] = this.lastName;
    data["title"] = this.title;
    data["phoneNumber"] = this.phoneNumber;
    data["faxNumber"] = this.faxNumber;
    data["cellPhoneNumber"] = this.cellPhoneNumber;
    data["emailAddress"] = this.emailAddress;
    data["note"] = this.note;
    data["isMainContact"] = this.isMainContact;
    data["role"] = this.role;
    data["lastContacted"] = this.lastContacted
      ? this.lastContacted.toISOString()
      : <any>undefined;
    return data;
  }
}

/** A data transfer object for requesting an update to a contact. */
export interface IUpdateVendorContactDto {
  /** The vendor's unique identifier. */
  vendorId: string;
  /** The contact's unique identifier. */
  contactId: string;
  /** The contact's first name. */
  firstName?: string | undefined;
  /** The contact's last name. */
  lastName?: string | undefined;
  /** The contact's title. */
  title?: string | undefined;
  /** The contact's phone number. */
  phoneNumber?: string | undefined;
  /** The contact's fax number. */
  faxNumber?: string | undefined;
  /** The contact's cell phone number. */
  cellPhoneNumber?: string | undefined;
  /** The contact's email address. */
  emailAddress?: string | undefined;
  /** The contact's note. */
  note?: string | undefined;
  /** A boolean indicating whether this contact is the company's main contact. */
  isMainContact?: boolean;
  /** A string specifying a contact's role. */
  role?: string | undefined;
  /** A DateTime when this contact was last contacted. */
  lastContacted?: Date | undefined;
  /** A location id this contact tie to */
  vendorLocationId?: string;
  /** Contact products */
  products?: IContactProduct[];
}

/** A data transfer object for requesting an update of an vendor minority status. */
export class UpdateVendorMinorityStatusDto
  implements IUpdateVendorMinorityStatusDto {
  /** The vendor's unique identifier. */
  vendorId!: string;
  /** The vendor minority status's unique identifier. */
  statusId!: string;
  /** The minority status type's unique identifier. */
  minorityTypeId!: string;
  /** The vendor's minority status certification number. */
  certificationNumber?: string | undefined;
  /** The vendor's minority percentage. */
  percent?: number;

  constructor(data?: IUpdateVendorMinorityStatusDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.vendorId = _data["vendorId"];
      this.statusId = _data["statusId"];
      this.minorityTypeId = _data["minorityTypeId"];
      this.certificationNumber = _data["certificationNumber"];
      this.percent = _data["percent"];
    }
  }

  static fromJS(data: any): UpdateVendorMinorityStatusDto {
    data = typeof data === "object" ? data : {};
    let result = new UpdateVendorMinorityStatusDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["vendorId"] = this.vendorId;
    data["statusId"] = this.statusId;
    data["minorityTypeId"] = this.minorityTypeId;
    data["certificationNumber"] = this.certificationNumber;
    data["percent"] = this.percent;
    return data;
  }
}

/** A data transfer object for requesting an update of an vendor minority status. */
export interface IUpdateVendorMinorityStatusDto {
  /** The vendor's unique identifier. */
  vendorId: string;
  /** The vendor minority status's unique identifier. */
  statusId: string;
  /** The minority status type's unique identifier. */
  minorityTypeId: string;
  /** The vendor's minority status certification number. */
  certificationNumber?: string | undefined;
  /** The vendor's minority percentage. */
  percent?: number;
}

/** A data transfer object for requesting the update of an vendor products. */
export class UpdateVendorProductDto implements IUpdateVendorProductDto {
  /** The vendor's unique identifier. */
  vendorId!: string;
  /** The vendor product's unique identifier. */
  productId!: string;
  /** The product types's unique identifier. */
  productTypeId!: string;
  /** The product region's unique identifier. */
  regionId?: string | undefined;
  /** The date. */
  date?: Date | undefined;

  constructor(data?: IUpdateVendorProductDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.vendorId = _data["vendorId"];
      this.productId = _data["productId"];
      this.productTypeId = _data["productTypeId"];
      this.regionId = _data["regionId"];
      this.date = _data["date"]
        ? new Date(_data["date"].toString())
        : <any>undefined;
    }
  }

  static fromJS(data: any): UpdateVendorProductDto {
    data = typeof data === "object" ? data : {};
    let result = new UpdateVendorProductDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["vendorId"] = this.vendorId;
    data["productId"] = this.productId;
    data["productTypeId"] = this.productTypeId;
    data["regionId"] = this.regionId;
    data["date"] = this.date ? this.date.toISOString() : <any>undefined;
    return data;
  }
}

/** A data transfer object for requesting the update of an vendor products. */
export interface IUpdateVendorProductDto {
  /** The vendor's unique identifier. */
  vendorId: string;
  /** The vendor product's unique identifier. */
  productId: string;
  /** The product types's unique identifier. */
  productTypeId: string;
  /** The product region's unique identifier. */
  regionId?: string | undefined;
  /** The date. */
  date?: Date | undefined;
}

/** An datat transfer object for requesting the creation of a company type. */
export class CreateCompanyTypeDto implements ICreateCompanyTypeDto {
  /** The unique company type code. */
  code!: string;
  /** The company type's description. */
  description?: string | undefined;

  constructor(data?: ICreateCompanyTypeDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.code = _data["code"];
      this.description = _data["description"];
    }
  }

  static fromJS(data: any): CreateCompanyTypeDto {
    data = typeof data === "object" ? data : {};
    let result = new CreateCompanyTypeDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["code"] = this.code;
    data["description"] = this.description;
    return data;
  }
}

/** An datat transfer object for requesting the creation of a company type. */
export interface ICreateCompanyTypeDto {
  /** The unique company type code. */
  code: string;
  /** The company type's description. */
  description?: string | undefined;
}

export class GetContactDto implements IGetContactDto {
  companyName?: string | undefined;
  id?: string;
  companyId?: string;
  firstName?: string | undefined;
  lastName?: string | undefined;
  title?: string | undefined;
  phoneNumber?: string | undefined;
  faxNumber?: string | undefined;
  cellPhoneNumber?: string | undefined;
  emailAddress?: string | undefined;
  isMainContact?: boolean;
  note?: string | undefined;
  /** A string specifying a contact's role. */
  role?: string | undefined;
  /** A DateTime when this contact was last contacted. */
  lastContacted?: Date | undefined;

  constructor(data?: IGetContactDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.companyName = _data["companyName"];
      this.id = _data["id"];
      this.companyId = _data["companyId"];
      this.firstName = _data["firstName"];
      this.lastName = _data["lastName"];
      this.title = _data["title"];
      this.phoneNumber = _data["phoneNumber"];
      this.faxNumber = _data["faxNumber"];
      this.cellPhoneNumber = _data["cellPhoneNumber"];
      this.emailAddress = _data["emailAddress"];
      this.isMainContact = _data["isMainContact"];
      this.note = _data["note"];
      this.role = _data["role"];
      this.lastContacted = _data["lastContacted"]
        ? new Date(_data["lastContacted"].toString())
        : <any>undefined;
    }
  }

  static fromJS(data: any): GetContactDto {
    data = typeof data === "object" ? data : {};
    let result = new GetContactDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["companyName"] = this.companyName;
    data["id"] = this.id;
    data["companyId"] = this.companyId;
    data["firstName"] = this.firstName;
    data["lastName"] = this.lastName;
    data["title"] = this.title;
    data["phoneNumber"] = this.phoneNumber;
    data["faxNumber"] = this.faxNumber;
    data["cellPhoneNumber"] = this.cellPhoneNumber;
    data["emailAddress"] = this.emailAddress;
    data["isMainContact"] = this.isMainContact;
    data["note"] = this.note;
    data["role"] = this.role;
    data["lastContacted"] = this.lastContacted
      ? this.lastContacted.toISOString()
      : <any>undefined;
    return data;
  }
}

export interface IGetContactDto {
  companyName?: string | undefined;
  id?: string;
  companyId?: string;
  firstName?: string | undefined;
  lastName?: string | undefined;
  title?: string | undefined;
  phoneNumber?: string | undefined;
  faxNumber?: string | undefined;
  cellPhoneNumber?: string | undefined;
  emailAddress?: string | undefined;
  isMainContact?: boolean;
  note?: string | undefined;
  /** A string specifying a contact's role. */
  role?: string | undefined;
  /** A DateTime when this contact was last contacted. */
  lastContacted?: Date | undefined;
}

export class GetContactSearchDto implements IGetContactSearchDto {
  id?: string;
  companyId?: string;
  companyName?: string | undefined;
  companyCode?: string | undefined;
  firstName?: string | undefined;
  lastName?: string | undefined;
  phoneNumber?: string | undefined;
  cellPhoneNumber?: string | undefined;
  emailAddress?: string | undefined;

  constructor(data?: IGetContactSearchDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.companyId = _data["companyId"];
      this.companyName = _data["companyName"];
      this.companyCode = _data["companyCode"];
      this.firstName = _data["firstName"];
      this.lastName = _data["lastName"];
      this.phoneNumber = _data["phoneNumber"];
      this.cellPhoneNumber = _data["cellPhoneNumber"];
      this.emailAddress = _data["emailAddress"];
    }
  }

  static fromJS(data: any): GetContactSearchDto {
    data = typeof data === "object" ? data : {};
    let result = new GetContactSearchDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.id;
    data["companyId"] = this.companyId;
    data["companyName"] = this.companyName;
    data["companyCode"] = this.companyCode;
    data["firstName"] = this.firstName;
    data["lastName"] = this.lastName;
    data["phoneNumber"] = this.phoneNumber;
    data["cellPhoneNumber"] = this.cellPhoneNumber;
    data["emailAddress"] = this.emailAddress;
    return data;
  }
}

export interface IGetContactSearchDto {
  id?: string;
  companyId?: string;
  companyName?: string | undefined;
  companyCode?: string | undefined;
  firstName?: string | undefined;
  lastName?: string | undefined;
  phoneNumber?: string | undefined;
  cellPhoneNumber?: string | undefined;
  emailAddress?: string | undefined;
}

/** A data transfer object for requesting the creation of a minority type. */
export class CreateMinorityTypeDto implements ICreateMinorityTypeDto {
  /** A unique minority type code. */
  code!: string;
  /** The minority type's description. */
  description?: string | undefined;

  constructor(data?: ICreateMinorityTypeDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.code = _data["code"];
      this.description = _data["description"];
    }
  }

  static fromJS(data: any): CreateMinorityTypeDto {
    data = typeof data === "object" ? data : {};
    let result = new CreateMinorityTypeDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["code"] = this.code;
    data["description"] = this.description;
    return data;
  }
}

/** A data transfer object for requesting the creation of a minority type. */
export interface ICreateMinorityTypeDto {
  /** A unique minority type code. */
  code: string;
  /** The minority type's description. */
  description?: string | undefined;
}

/** A data transfer object for requesting the creation of a product type. */
export class CreateProductTypeDto implements ICreateProductTypeDto {
  /** A unique product type code. */
  code!: string;
  /** The product type's description. */
  description?: string | undefined;

  constructor(data?: ICreateProductTypeDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.code = _data["code"];
      this.description = _data["description"];
    }
  }

  static fromJS(data: any): CreateProductTypeDto {
    data = typeof data === "object" ? data : {};
    let result = new CreateProductTypeDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["code"] = this.code;
    data["description"] = this.description;
    return data;
  }
}

/** A data transfer object for requesting the creation of a product type. */
export interface ICreateProductTypeDto {
  /** A unique product type code. */
  code: string;
  /** The product type's description. */
  description?: string | undefined;
}

export class PhoneNumber implements IPhoneNumber {
  number?: string | undefined;

  constructor(data?: IPhoneNumber) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.number = _data["number"];
    }
  }

  static fromJS(data: any): PhoneNumber {
    data = typeof data === "object" ? data : {};
    let result = new PhoneNumber();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["number"] = this.number;
    return data;
  }
}

export interface IPhoneNumber {
  number?: string | undefined;
}

export class ProfileSummaryDto implements IProfileSummaryDto {
  /** The Profile's unique identifier. */
  id?: string;
  name?: string | undefined;
  primaryAddress?: Address;
  phoneNumber?: PhoneNumber;
  webAddress?: string | undefined;
  region?: RegionDto;
  communicationMethod?: CommunicationMethod;
  /** The accent color for the company. */
  profileAccentColor?: string | undefined;
  /** The public logo url for the company. */
  profileLogoUrl?: string | undefined;

  constructor(data?: IProfileSummaryDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.name = _data["name"];
      this.primaryAddress = _data["primaryAddress"]
        ? Address.fromJS(_data["primaryAddress"])
        : <any>undefined;
      this.phoneNumber = _data["phoneNumber"]
        ? PhoneNumber.fromJS(_data["phoneNumber"])
        : <any>undefined;
      this.webAddress = _data["webAddress"];
      this.region = _data["region"]
        ? RegionDto.fromJS(_data["region"])
        : <any>undefined;
      this.communicationMethod = _data["communicationMethod"];
      this.profileAccentColor = _data["profileAccentColor"];
      this.profileLogoUrl = _data["profileLogoUrl"];
    }
  }

  static fromJS(data: any): ProfileSummaryDto {
    data = typeof data === "object" ? data : {};
    let result = new ProfileSummaryDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.id;
    data["name"] = this.name;
    data["primaryAddress"] = this.primaryAddress
      ? this.primaryAddress.toJSON()
      : <any>undefined;
    data["phoneNumber"] = this.phoneNumber
      ? this.phoneNumber.toJSON()
      : <any>undefined;
    data["webAddress"] = this.webAddress;
    data["region"] = this.region ? this.region.toJSON() : <any>undefined;
    data["communicationMethod"] = this.communicationMethod;
    data["profileAccentColor"] = this.profileAccentColor;
    data["profileLogoUrl"] = this.profileLogoUrl;
    return data;
  }
}

export interface IProfileSummaryDto {
  /** The Profile's unique identifier. */
  id?: string;
  name?: string | undefined;
  primaryAddress?: Address;
  phoneNumber?: PhoneNumber;
  webAddress?: string | undefined;
  region?: RegionDto;
  communicationMethod?: CommunicationMethod;
  /** The accent color for the company. */
  profileAccentColor?: string | undefined;
  /** The public logo url for the company. */
  profileLogoUrl?: string | undefined;
}

/** A data transfer object for requesting the creation of a company profile. */
export class CreateProfileDto implements ICreateProfileDto {
  /** The company's name. */
  name!: string;
  primaryAddress?: Address;
  alternateAddress?: Address;
  phoneNumber?: string | undefined;
  faxNumber?: string | undefined;
  /** The company's website address. */
  webAddress?: string | undefined;
  /** The unique identifier of the region the company operates in. */
  regionId?: string | undefined;
  communicationMethod?: CommunicationMethod;
  /** The accent color for the company. */
  profileAccentColor?: string | undefined;

  constructor(data?: ICreateProfileDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.name = _data["name"];
      this.primaryAddress = _data["primaryAddress"]
        ? Address.fromJS(_data["primaryAddress"])
        : <any>undefined;
      this.alternateAddress = _data["alternateAddress"]
        ? Address.fromJS(_data["alternateAddress"])
        : <any>undefined;
      this.phoneNumber = _data["phoneNumber"];
      this.faxNumber = _data["faxNumber"];
      this.webAddress = _data["webAddress"];
      this.regionId = _data["regionId"];
      this.communicationMethod = _data["communicationMethod"];
      this.profileAccentColor = _data["profileAccentColor"];
    }
  }

  static fromJS(data: any): CreateProfileDto {
    data = typeof data === "object" ? data : {};
    let result = new CreateProfileDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["name"] = this.name;
    data["primaryAddress"] = this.primaryAddress
      ? this.primaryAddress.toJSON()
      : <any>undefined;
    data["alternateAddress"] = this.alternateAddress
      ? this.alternateAddress.toJSON()
      : <any>undefined;
    data["phoneNumber"] = this.phoneNumber;
    data["faxNumber"] = this.faxNumber;
    data["webAddress"] = this.webAddress;
    data["regionId"] = this.regionId;
    data["communicationMethod"] = this.communicationMethod;
    data["profileAccentColor"] = this.profileAccentColor;
    return data;
  }
}

/** A data transfer object for requesting the creation of a company profile. */
export interface ICreateProfileDto {
  /** The company's name. */
  name: string;
  primaryAddress?: Address;
  alternateAddress?: Address;
  phoneNumber?: string | undefined;
  faxNumber?: string | undefined;
  /** The company's website address. */
  webAddress?: string | undefined;
  /** The unique identifier of the region the company operates in. */
  regionId?: string | undefined;
  communicationMethod?: CommunicationMethod;
  /** The accent color for the company. */
  profileAccentColor?: string | undefined;
}

/** A data transfer object for requesting the update to an existing company profile. */
export class UpdateProfileDto implements IUpdateProfileDto {
  /** The company's name. */
  name!: string;
  primaryAddress?: Address;
  alternateAddress?: Address;
  phoneNumber?: string | undefined;
  faxNumber?: string | undefined;
  /** The company's website address. */
  webAddress?: string | undefined;
  /** The unique identifier of the region the company operates in. */
  regionId?: string | undefined;
  communicationMethod?: CommunicationMethod;
  /** The accent color for the company. */
  profileAccentColor?: string | undefined;

  constructor(data?: IUpdateProfileDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.name = _data["name"];
      this.primaryAddress = _data["primaryAddress"]
        ? Address.fromJS(_data["primaryAddress"])
        : <any>undefined;
      this.alternateAddress = _data["alternateAddress"]
        ? Address.fromJS(_data["alternateAddress"])
        : <any>undefined;
      this.phoneNumber = _data["phoneNumber"];
      this.faxNumber = _data["faxNumber"];
      this.webAddress = _data["webAddress"];
      this.regionId = _data["regionId"];
      this.communicationMethod = _data["communicationMethod"];
      this.profileAccentColor = _data["profileAccentColor"];
    }
  }

  static fromJS(data: any): UpdateProfileDto {
    data = typeof data === "object" ? data : {};
    let result = new UpdateProfileDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["name"] = this.name;
    data["primaryAddress"] = this.primaryAddress
      ? this.primaryAddress.toJSON()
      : <any>undefined;
    data["alternateAddress"] = this.alternateAddress
      ? this.alternateAddress.toJSON()
      : <any>undefined;
    data["phoneNumber"] = this.phoneNumber;
    data["faxNumber"] = this.faxNumber;
    data["webAddress"] = this.webAddress;
    data["regionId"] = this.regionId;
    data["communicationMethod"] = this.communicationMethod;
    data["profileAccentColor"] = this.profileAccentColor;
    return data;
  }
}

/** A data transfer object for requesting the update to an existing company profile. */
export interface IUpdateProfileDto {
  /** The company's name. */
  name: string;
  primaryAddress?: Address;
  alternateAddress?: Address;
  phoneNumber?: string | undefined;
  faxNumber?: string | undefined;
  /** The company's website address. */
  webAddress?: string | undefined;
  /** The unique identifier of the region the company operates in. */
  regionId?: string | undefined;
  communicationMethod?: CommunicationMethod;
  /** The accent color for the company. */
  profileAccentColor?: string | undefined;
}

/** A data transfer object for requesting the creation of a region. */
export class CreateRegionDto implements ICreateRegionDto {
  /** Unique Region code. */
  code!: string;
  /** The Region description. */
  description?: string | undefined;

  constructor(data?: ICreateRegionDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.code = _data["code"];
      this.description = _data["description"];
    }
  }

  static fromJS(data: any): CreateRegionDto {
    data = typeof data === "object" ? data : {};
    let result = new CreateRegionDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["code"] = this.code;
    data["description"] = this.description;
    return data;
  }
}

/** A data transfer object for requesting the creation of a region. */
export interface ICreateRegionDto {
  /** Unique Region code. */
  code: string;
  /** The Region description. */
  description?: string | undefined;
}

/** A vendor summary data transfer object. */
export class VendorSummaryDtoResponse implements IVendorSummaryDtoResponse {
  /** The company's unique identifier. */
  id!: string;
  /** The company's unique code. */
  code!: string;
  /** The company's name. */
  name?: string | undefined;
  type?: CompanyTypeDto;
  region?: RegionDto;
  communicationMethod?: CommunicationMethod;
  /** A flag indicating if this company is bonded. */
  isBonded?: boolean;
  /** The rate at which this company is bonded. */
  bondRate?: number;
  /** Notes about this company. */
  note?: string | undefined;
  primaryAddress?: Address;
  /** The vendor's phone number. */
  phoneNumber?: string | undefined;
  /** The company's website address. */
  webAddress?: string | undefined;

  constructor(data?: IVendorSummaryDtoResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.code = _data["code"];
      this.name = _data["name"];
      this.type = _data["type"]
        ? CompanyTypeDto.fromJS(_data["type"])
        : <any>undefined;
      this.region = _data["region"]
        ? RegionDto.fromJS(_data["region"])
        : <any>undefined;
      this.communicationMethod = _data["communicationMethod"];
      this.isBonded = _data["isBonded"];
      this.bondRate = _data["bondRate"];
      this.note = _data["note"];
      this.primaryAddress = _data["primaryAddress"]
        ? Address.fromJS(_data["primaryAddress"])
        : <any>undefined;
      this.phoneNumber = _data["phoneNumber"];
      this.webAddress = _data["webAddress"];
    }
  }

  static fromJS(data: any): VendorSummaryDtoResponse {
    data = typeof data === "object" ? data : {};
    let result = new VendorSummaryDtoResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.id;
    data["code"] = this.code;
    data["name"] = this.name;
    data["type"] = this.type ? this.type.toJSON() : <any>undefined;
    data["region"] = this.region ? this.region.toJSON() : <any>undefined;
    data["communicationMethod"] = this.communicationMethod;
    data["isBonded"] = this.isBonded;
    data["bondRate"] = this.bondRate;
    data["note"] = this.note;
    data["primaryAddress"] = this.primaryAddress
      ? this.primaryAddress.toJSON()
      : <any>undefined;
    data["phoneNumber"] = this.phoneNumber;
    data["webAddress"] = this.webAddress;
    return data;
  }
}

/** A vendor summary data transfer object. */
export interface IVendorSummaryDtoResponse {
  /** The company's unique identifier. */
  id: string;
  /** The company's unique code. */
  code: string;
  /** The company's name. */
  name?: string | undefined;
  type?: CompanyTypeDto;
  region?: RegionDto;
  communicationMethod?: CommunicationMethod;
  /** A flag indicating if this company is bonded. */
  isBonded?: boolean;
  /** The rate at which this company is bonded. */
  bondRate?: number;
  /** Notes about this company. */
  note?: string | undefined;
  primaryAddress?: Address;
  /** The vendor's phone number. */
  phoneNumber?: string | undefined;
  /** The company's website address. */
  webAddress?: string | undefined;
}

/** A data transfer object for requesting the creation on a vendor. */
export class CreateVendorDto implements ICreateVendorDto {
  /** The vendor's unique code. */
  code!: string;
  /** The vendor's name. */
  name?: string | undefined;
  primaryAddress?: Address;
  alternateAddress?: Address;
  phoneNumber?: string | undefined;
  faxNumber?: string | undefined;
  /** The vendor's website address. */
  webAddress?: string | undefined;
  /** The unique identifier of the region the vendor operates in. */
  regionId?: string | undefined;
  communicationMethod?: CommunicationMethod;
  /** A flag indicating if this vendor is bonded. */
  isBonded?: boolean;
  /** The rate at which this vendor is bonded. */
  bondRate?: number;
  /** Notes about this vendor. */
  note?: string | undefined;
  companyType?: CompanyTypeDto;

  constructor(data?: ICreateVendorDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.code = _data["code"];
      this.name = _data["name"];
      this.primaryAddress = _data["primaryAddress"]
        ? Address.fromJS(_data["primaryAddress"])
        : <any>undefined;
      this.alternateAddress = _data["alternateAddress"]
        ? Address.fromJS(_data["alternateAddress"])
        : <any>undefined;
      this.phoneNumber = _data["phoneNumber"];
      this.faxNumber = _data["faxNumber"];
      this.webAddress = _data["webAddress"];
      this.regionId = _data["regionId"];
      this.communicationMethod = _data["communicationMethod"];
      this.isBonded = _data["isBonded"];
      this.bondRate = _data["bondRate"];
      this.note = _data["note"];
      this.companyType = _data["companyType"]
        ? CompanyTypeDto.fromJS(_data["companyType"])
        : <any>undefined;
    }
  }

  static fromJS(data: any): CreateVendorDto {
    data = typeof data === "object" ? data : {};
    let result = new CreateVendorDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["code"] = this.code;
    data["name"] = this.name;
    data["primaryAddress"] = this.primaryAddress
      ? this.primaryAddress.toJSON()
      : <any>undefined;
    data["alternateAddress"] = this.alternateAddress
      ? this.alternateAddress.toJSON()
      : <any>undefined;
    data["phoneNumber"] = this.phoneNumber;
    data["faxNumber"] = this.faxNumber;
    data["webAddress"] = this.webAddress;
    data["regionId"] = this.regionId;
    data["communicationMethod"] = this.communicationMethod;
    data["isBonded"] = this.isBonded;
    data["bondRate"] = this.bondRate;
    data["note"] = this.note;
    data["companyType"] = this.companyType
      ? this.companyType.toJSON()
      : <any>undefined;
    return data;
  }
}

/** A data transfer object for requesting the creation on a vendor. */
export interface ICreateVendorDto {
  /** The vendor's unique code. */
  code: string;
  /** The vendor's name. */
  name?: string | undefined;
  primaryAddress?: Address;
  alternateAddress?: Address;
  phoneNumber?: string | undefined;
  faxNumber?: string | undefined;
  /** The vendor's website address. */
  webAddress?: string | undefined;
  /** The unique identifier of the region the vendor operates in. */
  regionId?: string | undefined;
  communicationMethod?: CommunicationMethod;
  /** A flag indicating if this vendor is bonded. */
  isBonded?: boolean;
  /** The rate at which this vendor is bonded. */
  bondRate?: number;
  /** Notes about this vendor. */
  note?: string | undefined;
  companyType?: CompanyTypeDto;
}

/** An immutable command message for requesting the creation of a type. */
export class BulkImportTypeDto implements IBulkImportTypeDto {
  /** A unique type code. */
  code?: string | undefined;
  /** The type's description. */
  description?: string | undefined;

  constructor(data?: IBulkImportTypeDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.code = _data["code"];
      this.description = _data["description"];
    }
  }

  static fromJS(data: any): BulkImportTypeDto {
    data = typeof data === "object" ? data : {};
    let result = new BulkImportTypeDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["code"] = this.code;
    data["description"] = this.description;
    return data;
  }
}

/** An immutable command message for requesting the creation of a type. */
export interface IBulkImportTypeDto {
  /** A unique type code. */
  code?: string | undefined;
  /** The type's description. */
  description?: string | undefined;
}

export class BulkImportVendorContactDto implements IBulkImportVendorContactDto {
  /** The contact's first name. */
  firstName?: string | undefined;
  /** The contact's last name. */
  lastName?: string | undefined;
  /** The contact's title. */
  title?: string | undefined;
  /** The contact's phone number. */
  phoneNumber?: string | undefined;
  /** The contact's fax number. */
  faxNumber?: string | undefined;
  /** The contact's cell phone number. */
  cellPhoneNumber?: string | undefined;
  /** The contact's email address. */
  emailAddress?: string | undefined;
  /** The contact's note. */
  note?: string | undefined;
  /** A boolean indicating whether this contact is the company's main contact. */
  isMainContact?: boolean;

  constructor(data?: IBulkImportVendorContactDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.firstName = _data["firstName"];
      this.lastName = _data["lastName"];
      this.title = _data["title"];
      this.phoneNumber = _data["phoneNumber"];
      this.faxNumber = _data["faxNumber"];
      this.cellPhoneNumber = _data["cellPhoneNumber"];
      this.emailAddress = _data["emailAddress"];
      this.note = _data["note"];
      this.isMainContact = _data["isMainContact"];
    }
  }

  static fromJS(data: any): BulkImportVendorContactDto {
    data = typeof data === "object" ? data : {};
    let result = new BulkImportVendorContactDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["firstName"] = this.firstName;
    data["lastName"] = this.lastName;
    data["title"] = this.title;
    data["phoneNumber"] = this.phoneNumber;
    data["faxNumber"] = this.faxNumber;
    data["cellPhoneNumber"] = this.cellPhoneNumber;
    data["emailAddress"] = this.emailAddress;
    data["note"] = this.note;
    data["isMainContact"] = this.isMainContact;
    return data;
  }
}

export interface IBulkImportVendorContactDto {
  /** The contact's first name. */
  firstName?: string | undefined;
  /** The contact's last name. */
  lastName?: string | undefined;
  /** The contact's title. */
  title?: string | undefined;
  /** The contact's phone number. */
  phoneNumber?: string | undefined;
  /** The contact's fax number. */
  faxNumber?: string | undefined;
  /** The contact's cell phone number. */
  cellPhoneNumber?: string | undefined;
  /** The contact's email address. */
  emailAddress?: string | undefined;
  /** The contact's note. */
  note?: string | undefined;
  /** A boolean indicating whether this contact is the company's main contact. */
  isMainContact?: boolean;
}

export class BulkImportVendorMinorityStatusDto
  implements IBulkImportVendorMinorityStatusDto {
  /** The minority status type's unique identifier. */
  minorityTypeCode!: string;
  /** The vendor's minority status certification number. */
  certificationNumber?: string | undefined;
  /** The vendor's minority percentage. */
  percent?: number;

  constructor(data?: IBulkImportVendorMinorityStatusDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.minorityTypeCode = _data["minorityTypeCode"];
      this.certificationNumber = _data["certificationNumber"];
      this.percent = _data["percent"];
    }
  }

  static fromJS(data: any): BulkImportVendorMinorityStatusDto {
    data = typeof data === "object" ? data : {};
    let result = new BulkImportVendorMinorityStatusDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["minorityTypeCode"] = this.minorityTypeCode;
    data["certificationNumber"] = this.certificationNumber;
    data["percent"] = this.percent;
    return data;
  }
}

export interface IBulkImportVendorMinorityStatusDto {
  /** The minority status type's unique identifier. */
  minorityTypeCode: string;
  /** The vendor's minority status certification number. */
  certificationNumber?: string | undefined;
  /** The vendor's minority percentage. */
  percent?: number;
}

export class BulkImportVendorProductDto implements IBulkImportVendorProductDto {
  /** The product type's unique identifier. */
  productTypeCode!: string;
  /** The product region's unique identifier. */
  regionCode?: string | undefined;
  /** The date. */
  date?: Date | undefined;

  constructor(data?: IBulkImportVendorProductDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.productTypeCode = _data["productTypeCode"];
      this.regionCode = _data["regionCode"];
      this.date = _data["date"]
        ? new Date(_data["date"].toString())
        : <any>undefined;
    }
  }

  static fromJS(data: any): BulkImportVendorProductDto {
    data = typeof data === "object" ? data : {};
    let result = new BulkImportVendorProductDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["productTypeCode"] = this.productTypeCode;
    data["regionCode"] = this.regionCode;
    data["date"] = this.date ? this.date.toISOString() : <any>undefined;
    return data;
  }
}

export interface IBulkImportVendorProductDto {
  /** The product type's unique identifier. */
  productTypeCode: string;
  /** The product region's unique identifier. */
  regionCode?: string | undefined;
  /** The date. */
  date?: Date | undefined;
}

export class BulkImportVendorDto implements IBulkImportVendorDto {
  /** The vendor's unique code. */
  code?: string | undefined;
  /** The vendor's name. */
  name?: string | undefined;
  /** The vendor's type unique identifier. */
  typeCode?: string | undefined;
  /** The vendor's primary address. */
  primary_AddressLine1?: string | undefined;
  primary_AddressLine2?: string | undefined;
  primary_Building?: string | undefined;
  primary_City?: string | undefined;
  primary_StateProvince?: string | undefined;
  primary_CountryRegion?: string | undefined;
  primary_PostalCode?: string | undefined;
  /** The vendor's alternate address. */
  alternate_AddressLine1?: string | undefined;
  alternate_AddressLine2?: string | undefined;
  alternate_Building?: string | undefined;
  alternate_City?: string | undefined;
  alternate_StateProvince?: string | undefined;
  alternate_CountryRegion?: string | undefined;
  alternate_PostalCode?: string | undefined;
  phoneNumber?: string | undefined;
  faxNumber?: string | undefined;
  /** The vendor's website address. */
  webAddress?: string | undefined;
  /** The unique identifier of the region the vendor operates in. */
  regionCode?: string | undefined;
  communicationMethod?: CommunicationMethod;
  /** A flag indicating if this vendor is bonded. */
  isBonded?: boolean;
  /** The rate at which this vendor is bonded. */
  bondRate?: number;
  /** Notes about this vendor. */
  note?: string | undefined;
  contacts?: BulkImportVendorContactDto[] | undefined;
  minorityStatuses?: BulkImportVendorMinorityStatusDto[] | undefined;
  products?: BulkImportVendorProductDto[] | undefined;

  constructor(data?: IBulkImportVendorDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.code = _data["code"];
      this.name = _data["name"];
      this.typeCode = _data["typeCode"];
      this.primary_AddressLine1 = _data["primary_AddressLine1"];
      this.primary_AddressLine2 = _data["primary_AddressLine2"];
      this.primary_Building = _data["primary_Building"];
      this.primary_City = _data["primary_City"];
      this.primary_StateProvince = _data["primary_StateProvince"];
      this.primary_CountryRegion = _data["primary_CountryRegion"];
      this.primary_PostalCode = _data["primary_PostalCode"];
      this.alternate_AddressLine1 = _data["alternate_AddressLine1"];
      this.alternate_AddressLine2 = _data["alternate_AddressLine2"];
      this.alternate_Building = _data["alternate_Building"];
      this.alternate_City = _data["alternate_City"];
      this.alternate_StateProvince = _data["alternate_StateProvince"];
      this.alternate_CountryRegion = _data["alternate_CountryRegion"];
      this.alternate_PostalCode = _data["alternate_PostalCode"];
      this.phoneNumber = _data["phoneNumber"];
      this.faxNumber = _data["faxNumber"];
      this.webAddress = _data["webAddress"];
      this.regionCode = _data["regionCode"];
      this.communicationMethod = _data["communicationMethod"];
      this.isBonded = _data["isBonded"];
      this.bondRate = _data["bondRate"];
      this.note = _data["note"];
      if (Array.isArray(_data["contacts"])) {
        this.contacts = [] as any;
        for (let item of _data["contacts"])
          this.contacts!.push(BulkImportVendorContactDto.fromJS(item));
      }
      if (Array.isArray(_data["minorityStatuses"])) {
        this.minorityStatuses = [] as any;
        for (let item of _data["minorityStatuses"])
          this.minorityStatuses!.push(
            BulkImportVendorMinorityStatusDto.fromJS(item)
          );
      }
      if (Array.isArray(_data["products"])) {
        this.products = [] as any;
        for (let item of _data["products"])
          this.products!.push(BulkImportVendorProductDto.fromJS(item));
      }
    }
  }

  static fromJS(data: any): BulkImportVendorDto {
    data = typeof data === "object" ? data : {};
    let result = new BulkImportVendorDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["code"] = this.code;
    data["name"] = this.name;
    data["typeCode"] = this.typeCode;
    data["primary_AddressLine1"] = this.primary_AddressLine1;
    data["primary_AddressLine2"] = this.primary_AddressLine2;
    data["primary_Building"] = this.primary_Building;
    data["primary_City"] = this.primary_City;
    data["primary_StateProvince"] = this.primary_StateProvince;
    data["primary_CountryRegion"] = this.primary_CountryRegion;
    data["primary_PostalCode"] = this.primary_PostalCode;
    data["alternate_AddressLine1"] = this.alternate_AddressLine1;
    data["alternate_AddressLine2"] = this.alternate_AddressLine2;
    data["alternate_Building"] = this.alternate_Building;
    data["alternate_City"] = this.alternate_City;
    data["alternate_StateProvince"] = this.alternate_StateProvince;
    data["alternate_CountryRegion"] = this.alternate_CountryRegion;
    data["alternate_PostalCode"] = this.alternate_PostalCode;
    data["phoneNumber"] = this.phoneNumber;
    data["faxNumber"] = this.faxNumber;
    data["webAddress"] = this.webAddress;
    data["regionCode"] = this.regionCode;
    data["communicationMethod"] = this.communicationMethod;
    data["isBonded"] = this.isBonded;
    data["bondRate"] = this.bondRate;
    data["note"] = this.note;
    if (Array.isArray(this.contacts)) {
      data["contacts"] = [];
      for (let item of this.contacts) data["contacts"].push(item.toJSON());
    }
    if (Array.isArray(this.minorityStatuses)) {
      data["minorityStatuses"] = [];
      for (let item of this.minorityStatuses)
        data["minorityStatuses"].push(item.toJSON());
    }
    if (Array.isArray(this.products)) {
      data["products"] = [];
      for (let item of this.products) data["products"].push(item.toJSON());
    }
    return data;
  }
}

export interface IBulkImportVendorDto {
  /** The vendor's unique code. */
  code?: string | undefined;
  /** The vendor's name. */
  name?: string | undefined;
  /** The vendor's type unique identifier. */
  typeCode?: string | undefined;
  /** The vendor's primary address. */
  primary_AddressLine1?: string | undefined;
  primary_AddressLine2?: string | undefined;
  primary_Building?: string | undefined;
  primary_City?: string | undefined;
  primary_StateProvince?: string | undefined;
  primary_CountryRegion?: string | undefined;
  primary_PostalCode?: string | undefined;
  /** The vendor's alternate address. */
  alternate_AddressLine1?: string | undefined;
  alternate_AddressLine2?: string | undefined;
  alternate_Building?: string | undefined;
  alternate_City?: string | undefined;
  alternate_StateProvince?: string | undefined;
  alternate_CountryRegion?: string | undefined;
  alternate_PostalCode?: string | undefined;
  phoneNumber?: string | undefined;
  faxNumber?: string | undefined;
  /** The vendor's website address. */
  webAddress?: string | undefined;
  /** The unique identifier of the region the vendor operates in. */
  regionCode?: string | undefined;
  communicationMethod?: CommunicationMethod;
  /** A flag indicating if this vendor is bonded. */
  isBonded?: boolean;
  /** The rate at which this vendor is bonded. */
  bondRate?: number;
  /** Notes about this vendor. */
  note?: string | undefined;
  contacts?: BulkImportVendorContactDto[] | undefined;
  minorityStatuses?: BulkImportVendorMinorityStatusDto[] | undefined;
  products?: BulkImportVendorProductDto[] | undefined;
}

export class BulkImport implements IBulkImport {
  minorityTypes?: BulkImportTypeDto[] | undefined;
  productTypes?: BulkImportTypeDto[] | undefined;
  companyTypes?: BulkImportTypeDto[] | undefined;
  regions?: BulkImportTypeDto[] | undefined;
  vendors?: BulkImportVendorDto[] | undefined;

  constructor(data?: IBulkImport) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data["minorityTypes"])) {
        this.minorityTypes = [] as any;
        for (let item of _data["minorityTypes"])
          this.minorityTypes!.push(BulkImportTypeDto.fromJS(item));
      }
      if (Array.isArray(_data["productTypes"])) {
        this.productTypes = [] as any;
        for (let item of _data["productTypes"])
          this.productTypes!.push(BulkImportTypeDto.fromJS(item));
      }
      if (Array.isArray(_data["companyTypes"])) {
        this.companyTypes = [] as any;
        for (let item of _data["companyTypes"])
          this.companyTypes!.push(BulkImportTypeDto.fromJS(item));
      }
      if (Array.isArray(_data["regions"])) {
        this.regions = [] as any;
        for (let item of _data["regions"])
          this.regions!.push(BulkImportTypeDto.fromJS(item));
      }
      if (Array.isArray(_data["vendors"])) {
        this.vendors = [] as any;
        for (let item of _data["vendors"])
          this.vendors!.push(BulkImportVendorDto.fromJS(item));
      }
    }
  }

  static fromJS(data: any): BulkImport {
    data = typeof data === "object" ? data : {};
    let result = new BulkImport();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    if (Array.isArray(this.minorityTypes)) {
      data["minorityTypes"] = [];
      for (let item of this.minorityTypes)
        data["minorityTypes"].push(item.toJSON());
    }
    if (Array.isArray(this.productTypes)) {
      data["productTypes"] = [];
      for (let item of this.productTypes)
        data["productTypes"].push(item.toJSON());
    }
    if (Array.isArray(this.companyTypes)) {
      data["companyTypes"] = [];
      for (let item of this.companyTypes)
        data["companyTypes"].push(item.toJSON());
    }
    if (Array.isArray(this.regions)) {
      data["regions"] = [];
      for (let item of this.regions) data["regions"].push(item.toJSON());
    }
    if (Array.isArray(this.vendors)) {
      data["vendors"] = [];
      for (let item of this.vendors) data["vendors"].push(item.toJSON());
    }
    return data;
  }
}

export interface IBulkImport {
  minorityTypes?: BulkImportTypeDto[] | undefined;
  productTypes?: BulkImportTypeDto[] | undefined;
  companyTypes?: BulkImportTypeDto[] | undefined;
  regions?: BulkImportTypeDto[] | undefined;
  vendors?: BulkImportVendorDto[] | undefined;
}

/** A data transfer object for requesting the creation of a company contact. */
export class CreateProfileContactDto implements ICreateProfileContactDto {
  /** The contact's first name. */
  firstName?: string | undefined;
  /** The contact's last name. */
  lastName?: string | undefined;
  /** The contact's title. */
  title?: string | undefined;
  /** The contact's phone number. */
  phoneNumber?: string | undefined;
  /** The contact's fax number. */
  faxNumber?: string | undefined;
  /** The contact's cell phone number. */
  cellPhoneNumber?: string | undefined;
  /** The contact's email address. */
  emailAddress?: string | undefined;
  /** The contact's note. */
  note?: string | undefined;
  /** A boolean indicating whether this contact is the company's main contact. */
  isMainContact?: boolean;

  constructor(data?: ICreateProfileContactDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.firstName = _data["firstName"];
      this.lastName = _data["lastName"];
      this.title = _data["title"];
      this.phoneNumber = _data["phoneNumber"];
      this.faxNumber = _data["faxNumber"];
      this.cellPhoneNumber = _data["cellPhoneNumber"];
      this.emailAddress = _data["emailAddress"];
      this.note = _data["note"];
      this.isMainContact = _data["isMainContact"];
    }
  }

  static fromJS(data: any): CreateProfileContactDto {
    data = typeof data === "object" ? data : {};
    let result = new CreateProfileContactDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["firstName"] = this.firstName;
    data["lastName"] = this.lastName;
    data["title"] = this.title;
    data["phoneNumber"] = this.phoneNumber;
    data["faxNumber"] = this.faxNumber;
    data["cellPhoneNumber"] = this.cellPhoneNumber;
    data["emailAddress"] = this.emailAddress;
    data["note"] = this.note;
    data["isMainContact"] = this.isMainContact;
    return data;
  }
}

/** A data transfer object for requesting the creation of a company contact. */
export interface ICreateProfileContactDto {
  /** The contact's first name. */
  firstName?: string | undefined;
  /** The contact's last name. */
  lastName?: string | undefined;
  /** The contact's title. */
  title?: string | undefined;
  /** The contact's phone number. */
  phoneNumber?: string | undefined;
  /** The contact's fax number. */
  faxNumber?: string | undefined;
  /** The contact's cell phone number. */
  cellPhoneNumber?: string | undefined;
  /** The contact's email address. */
  emailAddress?: string | undefined;
  /** The contact's note. */
  note?: string | undefined;
  /** A boolean indicating whether this contact is the company's main contact. */
  isMainContact?: boolean;
}

/** A data transfer object for requesting the creation of an company minority status. */
export class CreateProfileMinorityStatusDto
  implements ICreateProfileMinorityStatusDto {
  /** The minority status type's unique identifier. */
  minorityTypeId!: string;
  /** The company's minority certification number. */
  certificationNumber?: string | undefined;
  /** The company's minority percentage. */
  percent?: number;

  constructor(data?: ICreateProfileMinorityStatusDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.minorityTypeId = _data["minorityTypeId"];
      this.certificationNumber = _data["certificationNumber"];
      this.percent = _data["percent"];
    }
  }

  static fromJS(data: any): CreateProfileMinorityStatusDto {
    data = typeof data === "object" ? data : {};
    let result = new CreateProfileMinorityStatusDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["minorityTypeId"] = this.minorityTypeId;
    data["certificationNumber"] = this.certificationNumber;
    data["percent"] = this.percent;
    return data;
  }
}

/** A data transfer object for requesting the creation of an company minority status. */
export interface ICreateProfileMinorityStatusDto {
  /** The minority status type's unique identifier. */
  minorityTypeId: string;
  /** The company's minority certification number. */
  certificationNumber?: string | undefined;
  /** The company's minority percentage. */
  percent?: number;
}

/** A data transfer object for requesting the creation of company products. */
export class CreateProfileProductDto implements ICreateProfileProductDto {
  /** The product type's unique identifier. */
  productTypeId!: string;
  /** The product region's unique identifier. */
  regionId?: string | undefined;
  /** The date. */
  date?: Date;

  constructor(data?: ICreateProfileProductDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.productTypeId = _data["productTypeId"];
      this.regionId = _data["regionId"];
      this.date = _data["date"]
        ? new Date(_data["date"].toString())
        : <any>undefined;
    }
  }

  static fromJS(data: any): CreateProfileProductDto {
    data = typeof data === "object" ? data : {};
    let result = new CreateProfileProductDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["productTypeId"] = this.productTypeId;
    data["regionId"] = this.regionId;
    data["date"] = this.date ? this.date.toISOString() : <any>undefined;
    return data;
  }
}

/** A data transfer object for requesting the creation of company products. */
export interface ICreateProfileProductDto {
  /** The product type's unique identifier. */
  productTypeId: string;
  /** The product region's unique identifier. */
  regionId?: string | undefined;
  /** The date. */
  date?: Date;
}

/** A data transfer object for requesting the creation of a vendor contact. */
export class CreateVendorContactDto implements ICreateVendorContactDto {
  /** The vendor's unique identifier. */
  vendorId!: string;
  /** The contact's first name. */
  firstName?: string | undefined;
  /** The contact's last name. */
  lastName?: string | undefined;
  /** The contact's title. */
  title?: string | undefined;
  /** The contact's phone number. */
  phoneNumber?: string | undefined;
  /** The contact's fax number. */
  faxNumber?: string | undefined;
  /** The contact's cell phone number. */
  cellPhoneNumber?: string | undefined;
  /** The contact's email address. */
  emailAddress?: string | undefined;
  /** The contact's note. */
  note?: string | undefined;
  /** A boolean indicating whether this contact is the company's main contact. */
  isMainContact?: boolean;
  /** A string specifying a contact's role. */
  role?: string | undefined;
  /** A DateTime when this contact was last contacted. */
  lastContacted?: Date | undefined;
  /** A location this contact tie to. */
  vendorLocationId?: string | undefined;
  /** Products this contact tie to. */
  products?: IContactProduct | undefined;
  constructor(data?: ICreateVendorContactDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.vendorId = _data["vendorId"];
      this.firstName = _data["firstName"];
      this.lastName = _data["lastName"];
      this.title = _data["title"];
      this.phoneNumber = _data["phoneNumber"];
      this.faxNumber = _data["faxNumber"];
      this.cellPhoneNumber = _data["cellPhoneNumber"];
      this.emailAddress = _data["emailAddress"];
      this.note = _data["note"];
      this.isMainContact = _data["isMainContact"];
      this.role = _data["role"];
      this.lastContacted = _data["lastContacted"]
        ? new Date(_data["lastContacted"].toString())
        : <any>undefined;
      this.vendorLocationId = _data["vendorLocationId"];
      this.products = _data["products"];
    }
  }

  static fromJS(data: any): CreateVendorContactDto {
    data = typeof data === "object" ? data : {};
    let result = new CreateVendorContactDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["vendorId"] = this.vendorId;
    data["firstName"] = this.firstName;
    data["lastName"] = this.lastName;
    data["title"] = this.title;
    data["phoneNumber"] = this.phoneNumber;
    data["faxNumber"] = this.faxNumber;
    data["cellPhoneNumber"] = this.cellPhoneNumber;
    data["emailAddress"] = this.emailAddress;
    data["note"] = this.note;
    data["isMainContact"] = this.isMainContact;
    data["role"] = this.role;
    data["lastContacted"] = this.lastContacted
      ? this.lastContacted.toISOString()
      : <any>undefined;
    data["vendorLocationId"] = this.vendorLocationId;
    data["products"] = this.products;
    return data;
  }
}

/** A data transfer object for requesting the creation of a vendor contact. */
export interface ICreateVendorContactDto {
  /** The vendor's unique identifier. */
  vendorId: string;
  /** The contact's first name. */
  firstName?: string | undefined;
  /** The contact's last name. */
  lastName?: string | undefined;
  /** The contact's title. */
  title?: string | undefined;
  /** The contact's phone number. */
  phoneNumber?: string | undefined;
  /** The contact's fax number. */
  faxNumber?: string | undefined;
  /** The contact's cell phone number. */
  cellPhoneNumber?: string | undefined;
  /** The contact's email address. */
  emailAddress?: string | undefined;
  /** The contact's note. */
  note?: string | undefined;
  /** A boolean indicating whether this contact is the company's main contact. */
  isMainContact?: boolean;
  /** A string specifying a contact's role. */
  role?: string | undefined;
  /** A DateTime when this contact was last contacted. */
  lastContacted?: Date | undefined;
}

/** A data transfer object for requesting the creation of an vendor minority status. */
export class CreateVendorMinorityStatusDto
  implements ICreateVendorMinorityStatusDto {
  /** The vendor's unique identifier. */
  vendorId!: string;
  /** The minority status type's unique identifier. */
  minorityTypeId!: string;
  /** The vendor's minority status certification number. */
  certificationNumber?: string | undefined;
  /** The vendor's minority percentage. */
  percent?: number;

  constructor(data?: ICreateVendorMinorityStatusDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.vendorId = _data["vendorId"];
      this.minorityTypeId = _data["minorityTypeId"];
      this.certificationNumber = _data["certificationNumber"];
      this.percent = _data["percent"];
    }
  }

  static fromJS(data: any): CreateVendorMinorityStatusDto {
    data = typeof data === "object" ? data : {};
    let result = new CreateVendorMinorityStatusDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["vendorId"] = this.vendorId;
    data["minorityTypeId"] = this.minorityTypeId;
    data["certificationNumber"] = this.certificationNumber;
    data["percent"] = this.percent;
    return data;
  }
}

/** A data transfer object for requesting the creation of an vendor minority status. */
export interface ICreateVendorMinorityStatusDto {
  /** The vendor's unique identifier. */
  vendorId: string;
  /** The minority status type's unique identifier. */
  minorityTypeId: string;
  /** The vendor's minority status certification number. */
  certificationNumber?: string | undefined;
  /** The vendor's minority percentage. */
  percent?: number;
}

/** A data transfer object for requesting the creation of vendor products. */
export class CreateVendorProductDto implements ICreateVendorProductDto {
  /** The vendor's unique identifier. */
  vendorId!: string;
  /** The product type's unique identifier. */
  productTypeId!: string;
  /** The product region's unique identifier. */
  regionId?: string | undefined;
  /** The date. */
  date?: Date | undefined;

  constructor(data?: ICreateVendorProductDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.vendorId = _data["vendorId"];
      this.productTypeId = _data["productTypeId"];
      this.regionId = _data["regionId"];
      this.date = _data["date"]
        ? new Date(_data["date"].toString())
        : <any>undefined;
    }
  }

  static fromJS(data: any): CreateVendorProductDto {
    data = typeof data === "object" ? data : {};
    let result = new CreateVendorProductDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["vendorId"] = this.vendorId;
    data["productTypeId"] = this.productTypeId;
    data["regionId"] = this.regionId;
    data["date"] = this.date ? this.date.toISOString() : <any>undefined;
    return data;
  }
}

/** A data transfer object for requesting the creation of vendor products. */
export interface ICreateVendorProductDto {
  /** The vendor's unique identifier. */
  vendorId: string;
  /** The product type's unique identifier. */
  productTypeId: string;
  /** The product region's unique identifier. */
  regionId?: string | undefined;
  /** The date. */
  date?: Date | undefined;
}

export class Body implements IBody {
  logo?: string | undefined;

  constructor(data?: IBody) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.logo = _data["logo"];
    }
  }

  static fromJS(data: any): Body {
    data = typeof data === "object" ? data : {};
    let result = new Body();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["logo"] = this.logo;
    return data;
  }
}

export interface IBody {
  logo?: string | undefined;
}

export interface FileParameter {
  data: any;
  fileName: string;
}

export class ApiException extends Error {
  message: string;
  status: number;
  response: string;
  headers: { [key: string]: any };
  result: any;

  constructor(
    message: string,
    status: number,
    response: string,
    headers: { [key: string]: any },
    result: any
  ) {
    super();

    this.message = message;
    this.status = status;
    this.response = response;
    this.headers = headers;
    this.result = result;
  }

  protected isApiException = true;

  static isApiException(obj: any): obj is ApiException {
    return obj.isApiException === true;
  }
}

function throwException(
  message: string,
  status: number,
  response: string,
  headers: { [key: string]: any },
  result?: any
): any {
  if (result !== null && result !== undefined) throw result;
  else throw new ApiException(message, status, response, headers, null);
}

function isAxiosError(obj: any | undefined): obj is AxiosError {
  return obj && obj.isAxiosError === true;
}
